import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import BN from 'bn.js';
import logger from 'ulog';
import Web3 from 'web3';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
/* Generated by ts-generator ver. 0.0.8 */

/* tslint:disable */


var AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f = [{
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  payable: true,
  stateMutability: "payable",
  type: "fallback"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "ReserveMigration",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "augmintToken",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "weiAmount",
    type: "uint256"
  }],
  name: "migrate",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}];
var AugmintReserves_ABI_fe74b7986dafb00f221486e790fc70ec = [{
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "tokenAddress",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }, {
    name: "weiAmount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "withdraw",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  payable: true,
  stateMutability: "payable",
  type: "fallback"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "tokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "narrative",
    type: "string"
  }],
  name: "WithdrawFromSystemAccount",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "augmintToken",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}];
var Exchange_ABI_b2a23202a9a0f04755a186896c2b56eb = [{
  constant: true,
  inputs: [{
    name: "",
    type: "uint64"
  }],
  name: "buyTokenOrders",
  outputs: [{
    name: "index",
    type: "uint64"
  }, {
    name: "maker",
    type: "address"
  }, {
    name: "price",
    type: "uint32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "orderCount",
  outputs: [{
    name: "",
    type: "uint64"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "rates",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint64"
  }],
  name: "sellTokenOrders",
  outputs: [{
    name: "index",
    type: "uint64"
  }, {
    name: "maker",
    type: "address"
  }, {
    name: "price",
    type: "uint32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_rates",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "orderId",
    type: "uint64"
  }, {
    indexed: true,
    name: "maker",
    type: "address"
  }, {
    indexed: false,
    name: "price",
    type: "uint32"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "NewOrder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "tokenBuyer",
    type: "address"
  }, {
    indexed: true,
    name: "tokenSeller",
    type: "address"
  }, {
    indexed: false,
    name: "buyTokenOrderId",
    type: "uint64"
  }, {
    indexed: false,
    name: "sellTokenOrderId",
    type: "uint64"
  }, {
    indexed: false,
    name: "publishedRate",
    type: "uint256"
  }, {
    indexed: false,
    name: "price",
    type: "uint32"
  }, {
    indexed: false,
    name: "fillRate",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }],
  name: "OrderFill",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "orderId",
    type: "uint64"
  }, {
    indexed: true,
    name: "maker",
    type: "address"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "CancelledOrder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newRatesContract",
    type: "address"
  }],
  name: "RatesContractChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "newRatesContract",
    type: "address"
  }],
  name: "setRatesContract",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "price",
    type: "uint32"
  }],
  name: "placeBuyTokenOrder",
  outputs: [{
    name: "orderId",
    type: "uint64"
  }],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "price",
    type: "uint32"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }],
  name: "placeSellTokenOrder",
  outputs: [{
    name: "orderId",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "maker",
    type: "address"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }, {
    name: "price",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenId",
    type: "uint64"
  }],
  name: "cancelBuyTokenOrder",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "sellTokenId",
    type: "uint64"
  }],
  name: "cancelSellTokenOrder",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenId",
    type: "uint64"
  }, {
    name: "sellTokenId",
    type: "uint64"
  }],
  name: "matchOrders",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenIds",
    type: "uint64[]"
  }, {
    name: "sellTokenIds",
    type: "uint64[]"
  }],
  name: "matchMultipleOrders",
  outputs: [{
    name: "matchCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getActiveOrderCounts",
  outputs: [{
    name: "buyTokenOrderCount",
    type: "uint256"
  }, {
    name: "sellTokenOrderCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getActiveBuyOrders",
  outputs: [{
    name: "response",
    type: "uint256[4][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getActiveSellOrders",
  outputs: [{
    name: "response",
    type: "uint256[4][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var Exchange_ABI_c28de2392aea85ef2aa1b108fce6568c = [{
  constant: true,
  inputs: [{
    name: "",
    type: "uint64"
  }],
  name: "buyTokenOrders",
  outputs: [{
    name: "index",
    type: "uint64"
  }, {
    name: "maker",
    type: "address"
  }, {
    name: "price",
    type: "uint32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "orderCount",
  outputs: [{
    name: "",
    type: "uint64"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "rates",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint64"
  }],
  name: "sellTokenOrders",
  outputs: [{
    name: "index",
    type: "uint64"
  }, {
    name: "maker",
    type: "address"
  }, {
    name: "price",
    type: "uint32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_rates",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "orderId",
    type: "uint64"
  }, {
    indexed: true,
    name: "maker",
    type: "address"
  }, {
    indexed: false,
    name: "price",
    type: "uint32"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "NewOrder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "tokenBuyer",
    type: "address"
  }, {
    indexed: true,
    name: "tokenSeller",
    type: "address"
  }, {
    indexed: false,
    name: "buyTokenOrderId",
    type: "uint64"
  }, {
    indexed: false,
    name: "sellTokenOrderId",
    type: "uint64"
  }, {
    indexed: false,
    name: "publishedRate",
    type: "uint256"
  }, {
    indexed: false,
    name: "price",
    type: "uint32"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }],
  name: "OrderFill",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "orderId",
    type: "uint64"
  }, {
    indexed: true,
    name: "maker",
    type: "address"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "CancelledOrder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newRatesContract",
    type: "address"
  }],
  name: "RatesContractChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "newRatesContract",
    type: "address"
  }],
  name: "setRatesContract",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "price",
    type: "uint32"
  }],
  name: "placeBuyTokenOrder",
  outputs: [{
    name: "orderId",
    type: "uint64"
  }],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "price",
    type: "uint32"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }],
  name: "placeSellTokenOrder",
  outputs: [{
    name: "orderId",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "maker",
    type: "address"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }, {
    name: "price",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenId",
    type: "uint64"
  }],
  name: "cancelBuyTokenOrder",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "sellTokenId",
    type: "uint64"
  }],
  name: "cancelSellTokenOrder",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenId",
    type: "uint64"
  }, {
    name: "sellTokenId",
    type: "uint64"
  }],
  name: "matchOrders",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenIds",
    type: "uint64[]"
  }, {
    name: "sellTokenIds",
    type: "uint64[]"
  }],
  name: "matchMultipleOrders",
  outputs: [{
    name: "matchCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getActiveOrderCounts",
  outputs: [{
    name: "buyTokenOrderCount",
    type: "uint256"
  }, {
    name: "sellTokenOrderCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getActiveBuyOrders",
  outputs: [{
    name: "response",
    type: "uint256[4][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getActiveSellOrders",
  outputs: [{
    name: "response",
    type: "uint256[4][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd = [{
  constant: true,
  inputs: [{
    name: "",
    type: "uint64"
  }],
  name: "buyTokenOrders",
  outputs: [{
    name: "index",
    type: "uint64"
  }, {
    name: "maker",
    type: "address"
  }, {
    name: "price",
    type: "uint32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "orderCount",
  outputs: [{
    name: "",
    type: "uint64"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "rates",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint64"
  }],
  name: "sellTokenOrders",
  outputs: [{
    name: "index",
    type: "uint64"
  }, {
    name: "maker",
    type: "address"
  }, {
    name: "price",
    type: "uint32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_rates",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "orderId",
    type: "uint64"
  }, {
    indexed: true,
    name: "maker",
    type: "address"
  }, {
    indexed: false,
    name: "price",
    type: "uint32"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "NewOrder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "tokenBuyer",
    type: "address"
  }, {
    indexed: true,
    name: "tokenSeller",
    type: "address"
  }, {
    indexed: false,
    name: "buyTokenOrderId",
    type: "uint64"
  }, {
    indexed: false,
    name: "sellTokenOrderId",
    type: "uint64"
  }, {
    indexed: false,
    name: "publishedRate",
    type: "uint256"
  }, {
    indexed: false,
    name: "price",
    type: "uint32"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }],
  name: "OrderFill",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "orderId",
    type: "uint64"
  }, {
    indexed: true,
    name: "maker",
    type: "address"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }],
  name: "CancelledOrder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newRatesContract",
    type: "address"
  }],
  name: "RatesContractChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "newRatesContract",
    type: "address"
  }],
  name: "setRatesContract",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "price",
    type: "uint32"
  }],
  name: "placeBuyTokenOrder",
  outputs: [{
    name: "orderId",
    type: "uint64"
  }],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "price",
    type: "uint32"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }],
  name: "placeSellTokenOrder",
  outputs: [{
    name: "orderId",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "maker",
    type: "address"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }, {
    name: "price",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenId",
    type: "uint64"
  }],
  name: "cancelBuyTokenOrder",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "sellTokenId",
    type: "uint64"
  }],
  name: "cancelSellTokenOrder",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenId",
    type: "uint64"
  }, {
    name: "sellTokenId",
    type: "uint64"
  }],
  name: "matchOrders",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "buyTokenIds",
    type: "uint64[]"
  }, {
    name: "sellTokenIds",
    type: "uint64[]"
  }],
  name: "matchMultipleOrders",
  outputs: [{
    name: "matchCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getActiveOrderCounts",
  outputs: [{
    name: "buyTokenOrderCount",
    type: "uint256"
  }, {
    name: "sellTokenOrderCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getActiveBuyOrders",
  outputs: [{
    name: "",
    type: "uint256[4][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getActiveSellOrders",
  outputs: [{
    name: "",
    type: "uint256[4][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var FeeAccount_ABI_67db260db12738df3cced3511d34c65c = [{
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "tokenAddress",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }, {
    name: "weiAmount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "withdraw",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "transferFee",
  outputs: [{
    name: "pt",
    type: "uint256"
  }, {
    name: "min",
    type: "uint256"
  }, {
    name: "max",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "transferFeePt",
    type: "uint256"
  }, {
    name: "transferFeeMin",
    type: "uint256"
  }, {
    name: "transferFeeMax",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  payable: true,
  stateMutability: "payable",
  type: "fallback"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "transferFeePt",
    type: "uint256"
  }, {
    indexed: false,
    name: "transferFeeMin",
    type: "uint256"
  }, {
    indexed: false,
    name: "transferFeeMax",
    type: "uint256"
  }],
  name: "TransferFeesChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "tokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "narrative",
    type: "string"
  }],
  name: "WithdrawFromSystemAccount",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "transferFeePt",
    type: "uint256"
  }, {
    name: "transferFeeMin",
    type: "uint256"
  }, {
    name: "transferFeeMax",
    type: "uint256"
  }],
  name: "setTransferFees",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "calculateTransferFee",
  outputs: [{
    name: "fee",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "weiAmount",
    type: "uint256"
  }],
  name: "calculateExchangeFee",
  outputs: [{
    name: "weiFee",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f = [{
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "tokenAddress",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "tokenAmount",
    type: "uint256"
  }, {
    name: "weiAmount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "withdraw",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "tokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "tokenAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "weiAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "narrative",
    type: "string"
  }],
  name: "WithdrawFromSystemAccount",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "augmintToken",
    type: "address"
  }, {
    name: "locker",
    type: "address"
  }, {
    name: "interestAmount",
    type: "uint256"
  }],
  name: "transferInterest",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}];
var LoanManager_ABI_753a73f4b2140507197a8f80bff47b40 = [{
  constant: true,
  inputs: [],
  name: "monetarySupervisor",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "rates",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "accountLoans",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "products",
  outputs: [{
    name: "minDisbursedAmount",
    type: "uint256"
  }, {
    name: "term",
    type: "uint32"
  }, {
    name: "discountRate",
    type: "uint32"
  }, {
    name: "initialCollateralRatio",
    type: "uint32"
  }, {
    name: "defaultingFeePt",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }, {
    name: "minCollateralRatio",
    type: "uint32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "loans",
  outputs: [{
    name: "collateralAmount",
    type: "uint256"
  }, {
    name: "repaymentAmount",
    type: "uint256"
  }, {
    name: "borrower",
    type: "address"
  }, {
    name: "productId",
    type: "uint32"
  }, {
    name: "state",
    type: "uint8"
  }, {
    name: "maturity",
    type: "uint40"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_monetarySupervisor",
    type: "address"
  }, {
    name: "_rates",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }, {
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collateralAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "loanAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "repaymentAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "maturity",
    type: "uint40"
  }, {
    indexed: false,
    name: "currentRate",
    type: "uint256"
  }],
  name: "NewLoan",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collateralAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "repaymentAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "currentRate",
    type: "uint256"
  }],
  name: "LoanChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }, {
    indexed: false,
    name: "newState",
    type: "bool"
  }],
  name: "LoanProductActiveStateChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }],
  name: "LoanProductAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "currentRate",
    type: "uint256"
  }],
  name: "LoanRepaid",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collectedCollateral",
    type: "uint256"
  }, {
    indexed: false,
    name: "releasedCollateral",
    type: "uint256"
  }, {
    indexed: false,
    name: "defaultingFee",
    type: "uint256"
  }, {
    indexed: false,
    name: "currentRate",
    type: "uint256"
  }],
  name: "LoanCollected",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newRatesContract",
    type: "address"
  }, {
    indexed: false,
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "SystemContractsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "term",
    type: "uint32"
  }, {
    name: "discountRate",
    type: "uint32"
  }, {
    name: "initialCollateralRatio",
    type: "uint32"
  }, {
    name: "minDisbursedAmount",
    type: "uint256"
  }, {
    name: "defaultingFeePt",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }, {
    name: "minCollateralRatio",
    type: "uint32"
  }],
  name: "addLoanProduct",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "productId",
    type: "uint32"
  }, {
    name: "newState",
    type: "bool"
  }],
  name: "setLoanProductActiveState",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "productId",
    type: "uint32"
  }, {
    name: "minRate",
    type: "uint256"
  }],
  name: "newEthBackedLoan",
  outputs: [],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "loanId",
    type: "uint256"
  }],
  name: "addExtraCollateral",
  outputs: [],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "repaymentAmount",
    type: "uint256"
  }, {
    name: "loanId",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "loanIds",
    type: "uint256[]"
  }],
  name: "collect",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newRatesContract",
    type: "address"
  }, {
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "setSystemContracts",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getProductCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getProducts",
  outputs: [{
    name: "",
    type: "uint256[9][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLoanCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLoans",
  outputs: [{
    name: "",
    type: "uint256[12][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "borrower",
    type: "address"
  }],
  name: "getLoanCountForAddress",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "borrower",
    type: "address"
  }, {
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLoansForAddress",
  outputs: [{
    name: "",
    type: "uint256[12][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "loanId",
    type: "uint256"
  }],
  name: "getLoanTuple",
  outputs: [{
    name: "result",
    type: "uint256[12]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var LoanManager_ABI_ec709c3341045caa3a75374b8cfc7286 = [{
  constant: true,
  inputs: [],
  name: "monetarySupervisor",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "rates",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "accountLoans",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "products",
  outputs: [{
    name: "minDisbursedAmount",
    type: "uint256"
  }, {
    name: "term",
    type: "uint32"
  }, {
    name: "discountRate",
    type: "uint32"
  }, {
    name: "collateralRatio",
    type: "uint32"
  }, {
    name: "defaultingFeePt",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "loans",
  outputs: [{
    name: "collateralAmount",
    type: "uint256"
  }, {
    name: "repaymentAmount",
    type: "uint256"
  }, {
    name: "borrower",
    type: "address"
  }, {
    name: "productId",
    type: "uint32"
  }, {
    name: "state",
    type: "uint8"
  }, {
    name: "maturity",
    type: "uint40"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint16"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_monetarySupervisor",
    type: "address"
  }, {
    name: "_rates",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }, {
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collateralAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "loanAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "repaymentAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "maturity",
    type: "uint40"
  }],
  name: "NewLoan",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }, {
    indexed: false,
    name: "newState",
    type: "bool"
  }],
  name: "LoanProductActiveStateChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }],
  name: "LoanProductAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: false,
    name: "borrower",
    type: "address"
  }],
  name: "LoanRepayed",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collectedCollateral",
    type: "uint256"
  }, {
    indexed: false,
    name: "releasedCollateral",
    type: "uint256"
  }, {
    indexed: false,
    name: "defaultingFee",
    type: "uint256"
  }],
  name: "LoanCollected",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newRatesContract",
    type: "address"
  }, {
    indexed: false,
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "SystemContractsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "term",
    type: "uint32"
  }, {
    name: "discountRate",
    type: "uint32"
  }, {
    name: "collateralRatio",
    type: "uint32"
  }, {
    name: "minDisbursedAmount",
    type: "uint256"
  }, {
    name: "defaultingFeePt",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  name: "addLoanProduct",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "productId",
    type: "uint32"
  }, {
    name: "newState",
    type: "bool"
  }],
  name: "setLoanProductActiveState",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "productId",
    type: "uint32"
  }],
  name: "newEthBackedLoan",
  outputs: [],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "repaymentAmount",
    type: "uint256"
  }, {
    name: "loanId",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "loanIds",
    type: "uint256[]"
  }],
  name: "collect",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newRatesContract",
    type: "address"
  }, {
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "setSystemContracts",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getProductCount",
  outputs: [{
    name: "ct",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getProducts",
  outputs: [{
    name: "response",
    type: "uint256[8][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLoanCount",
  outputs: [{
    name: "ct",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getLoans",
  outputs: [{
    name: "response",
    type: "uint256[10][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "borrower",
    type: "address"
  }],
  name: "getLoanCountForAddress",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "borrower",
    type: "address"
  }, {
    name: "offset",
    type: "uint256"
  }],
  name: "getLoansForAddress",
  outputs: [{
    name: "response",
    type: "uint256[10][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "loanId",
    type: "uint256"
  }],
  name: "getLoanTuple",
  outputs: [{
    name: "result",
    type: "uint256[10]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb = [{
  constant: true,
  inputs: [],
  name: "monetarySupervisor",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "rates",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "accountLoans",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "products",
  outputs: [{
    name: "minDisbursedAmount",
    type: "uint256"
  }, {
    name: "term",
    type: "uint32"
  }, {
    name: "discountRate",
    type: "uint32"
  }, {
    name: "collateralRatio",
    type: "uint32"
  }, {
    name: "defaultingFeePt",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "loans",
  outputs: [{
    name: "collateralAmount",
    type: "uint256"
  }, {
    name: "repaymentAmount",
    type: "uint256"
  }, {
    name: "borrower",
    type: "address"
  }, {
    name: "productId",
    type: "uint32"
  }, {
    name: "state",
    type: "uint8"
  }, {
    name: "maturity",
    type: "uint40"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_monetarySupervisor",
    type: "address"
  }, {
    name: "_rates",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }, {
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collateralAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "loanAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "repaymentAmount",
    type: "uint256"
  }, {
    indexed: false,
    name: "maturity",
    type: "uint40"
  }],
  name: "NewLoan",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }, {
    indexed: false,
    name: "newState",
    type: "bool"
  }],
  name: "LoanProductActiveStateChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "productId",
    type: "uint32"
  }],
  name: "LoanProductAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: false,
    name: "borrower",
    type: "address"
  }],
  name: "LoanRepayed",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "loanId",
    type: "uint256"
  }, {
    indexed: true,
    name: "borrower",
    type: "address"
  }, {
    indexed: false,
    name: "collectedCollateral",
    type: "uint256"
  }, {
    indexed: false,
    name: "releasedCollateral",
    type: "uint256"
  }, {
    indexed: false,
    name: "defaultingFee",
    type: "uint256"
  }],
  name: "LoanCollected",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newRatesContract",
    type: "address"
  }, {
    indexed: false,
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "SystemContractsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "term",
    type: "uint32"
  }, {
    name: "discountRate",
    type: "uint32"
  }, {
    name: "collateralRatio",
    type: "uint32"
  }, {
    name: "minDisbursedAmount",
    type: "uint256"
  }, {
    name: "defaultingFeePt",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  name: "addLoanProduct",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "productId",
    type: "uint32"
  }, {
    name: "newState",
    type: "bool"
  }],
  name: "setLoanProductActiveState",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "productId",
    type: "uint32"
  }],
  name: "newEthBackedLoan",
  outputs: [],
  payable: true,
  stateMutability: "payable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "repaymentAmount",
    type: "uint256"
  }, {
    name: "loanId",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "loanIds",
    type: "uint256[]"
  }],
  name: "collect",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newRatesContract",
    type: "address"
  }, {
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "setSystemContracts",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getProductCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getProducts",
  outputs: [{
    name: "",
    type: "uint256[8][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLoanCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLoans",
  outputs: [{
    name: "",
    type: "uint256[10][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "borrower",
    type: "address"
  }],
  name: "getLoanCountForAddress",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "borrower",
    type: "address"
  }, {
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLoansForAddress",
  outputs: [{
    name: "",
    type: "uint256[10][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "loanId",
    type: "uint256"
  }],
  name: "getLoanTuple",
  outputs: [{
    name: "result",
    type: "uint256[10]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var Locker_ABI_619ff7809b73aead28176fe6317953c3 = [{
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "lockProducts",
  outputs: [{
    name: "perTermInterest",
    type: "uint32"
  }, {
    name: "durationInSecs",
    type: "uint32"
  }, {
    name: "minimumLockAmount",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "monetarySupervisor",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "accountLocks",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "locks",
  outputs: [{
    name: "amountLocked",
    type: "uint256"
  }, {
    name: "owner",
    type: "address"
  }, {
    name: "productId",
    type: "uint32"
  }, {
    name: "lockedUntil",
    type: "uint40"
  }, {
    name: "isActive",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_monetarySupervisor",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockProductId",
    type: "uint32"
  }, {
    indexed: false,
    name: "perTermInterest",
    type: "uint32"
  }, {
    indexed: false,
    name: "durationInSecs",
    type: "uint32"
  }, {
    indexed: false,
    name: "minimumLockAmount",
    type: "uint32"
  }, {
    indexed: false,
    name: "isActive",
    type: "bool"
  }],
  name: "NewLockProduct",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockProductId",
    type: "uint32"
  }, {
    indexed: false,
    name: "newActiveState",
    type: "bool"
  }],
  name: "LockProductActiveChange",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockOwner",
    type: "address"
  }, {
    indexed: false,
    name: "lockId",
    type: "uint256"
  }, {
    indexed: false,
    name: "amountLocked",
    type: "uint256"
  }, {
    indexed: false,
    name: "interestEarned",
    type: "uint256"
  }, {
    indexed: false,
    name: "lockedUntil",
    type: "uint40"
  }, {
    indexed: false,
    name: "perTermInterest",
    type: "uint32"
  }, {
    indexed: false,
    name: "durationInSecs",
    type: "uint32"
  }],
  name: "NewLock",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockOwner",
    type: "address"
  }, {
    indexed: false,
    name: "lockId",
    type: "uint256"
  }],
  name: "LockReleased",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "MonetarySupervisorChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "perTermInterest",
    type: "uint32"
  }, {
    name: "durationInSecs",
    type: "uint32"
  }, {
    name: "minimumLockAmount",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  name: "addLockProduct",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockProductId",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  name: "setLockProductActiveState",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "amountToLock",
    type: "uint256"
  }, {
    name: "_lockProductId",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockId",
    type: "uint256"
  }],
  name: "releaseFunds",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "setMonetarySupervisor",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLockProductCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getLockProducts",
  outputs: [{
    name: "response",
    type: "uint256[5][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLockCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "lockOwner",
    type: "address"
  }],
  name: "getLockCountForAddress",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getLocks",
  outputs: [{
    name: "response",
    type: "uint256[8][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "lockOwner",
    type: "address"
  }, {
    name: "offset",
    type: "uint256"
  }],
  name: "getLocksForAddress",
  outputs: [{
    name: "response",
    type: "uint256[7][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "perTermInterest",
    type: "uint32"
  }, {
    name: "amountToLock",
    type: "uint256"
  }],
  name: "calculateInterest",
  outputs: [{
    name: "interestEarned",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}];
var Locker_ABI_f59526398823aef0f0c1454d0b6b4eac = [{
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "lockProducts",
  outputs: [{
    name: "perTermInterest",
    type: "uint32"
  }, {
    name: "durationInSecs",
    type: "uint32"
  }, {
    name: "minimumLockAmount",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "monetarySupervisor",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "accountLocks",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "locks",
  outputs: [{
    name: "amountLocked",
    type: "uint256"
  }, {
    name: "owner",
    type: "address"
  }, {
    name: "productId",
    type: "uint32"
  }, {
    name: "lockedUntil",
    type: "uint40"
  }, {
    name: "isActive",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_monetarySupervisor",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockProductId",
    type: "uint32"
  }, {
    indexed: false,
    name: "perTermInterest",
    type: "uint32"
  }, {
    indexed: false,
    name: "durationInSecs",
    type: "uint32"
  }, {
    indexed: false,
    name: "minimumLockAmount",
    type: "uint32"
  }, {
    indexed: false,
    name: "isActive",
    type: "bool"
  }],
  name: "NewLockProduct",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockProductId",
    type: "uint32"
  }, {
    indexed: false,
    name: "newActiveState",
    type: "bool"
  }],
  name: "LockProductActiveChange",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockOwner",
    type: "address"
  }, {
    indexed: false,
    name: "lockId",
    type: "uint256"
  }, {
    indexed: false,
    name: "amountLocked",
    type: "uint256"
  }, {
    indexed: false,
    name: "interestEarned",
    type: "uint256"
  }, {
    indexed: false,
    name: "lockedUntil",
    type: "uint40"
  }, {
    indexed: false,
    name: "perTermInterest",
    type: "uint32"
  }, {
    indexed: false,
    name: "durationInSecs",
    type: "uint32"
  }],
  name: "NewLock",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lockOwner",
    type: "address"
  }, {
    indexed: false,
    name: "lockId",
    type: "uint256"
  }],
  name: "LockReleased",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "MonetarySupervisorChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "perTermInterest",
    type: "uint32"
  }, {
    name: "durationInSecs",
    type: "uint32"
  }, {
    name: "minimumLockAmount",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  name: "addLockProduct",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockProductId",
    type: "uint32"
  }, {
    name: "isActive",
    type: "bool"
  }],
  name: "setLockProductActiveState",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "amountToLock",
    type: "uint256"
  }, {
    name: "_lockProductId",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockId",
    type: "uint256"
  }],
  name: "releaseFunds",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newMonetarySupervisor",
    type: "address"
  }],
  name: "setMonetarySupervisor",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLockProductCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLockProducts",
  outputs: [{
    name: "",
    type: "uint256[5][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLockCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "lockOwner",
    type: "address"
  }],
  name: "getLockCountForAddress",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLocks",
  outputs: [{
    name: "",
    type: "uint256[8][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "lockOwner",
    type: "address"
  }, {
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getLocksForAddress",
  outputs: [{
    name: "",
    type: "uint256[7][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "perTermInterest",
    type: "uint32"
  }, {
    name: "amountToLock",
    type: "uint256"
  }],
  name: "calculateInterest",
  outputs: [{
    name: "interestEarned",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "pure",
  type: "function"
}];
var Migrations_ABI_78141a323f4a8416891b06a0a2b90065 = [{
  constant: true,
  inputs: [],
  name: "last_completed_migration",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "owner",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  constant: false,
  inputs: [{
    name: "completed",
    type: "uint256"
  }],
  name: "setCompleted",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newAddress",
    type: "address"
  }],
  name: "upgrade",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}];
var MonetarySupervisor_ABI_54d27fedd8bf3010ad5509866a42c053 = [{
  constant: true,
  inputs: [],
  name: "totalLockedAmount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "ltdParams",
  outputs: [{
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalLoanAmount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "interestEarnedAccount",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "issuedByStabilityBoard",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "PERCENT_100",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "acceptedLegacyAugmintTokens",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintReserves",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_augmintReserves",
    type: "address"
  }, {
    name: "_interestEarnedAccount",
    type: "address"
  }, {
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    indexed: false,
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    indexed: false,
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  name: "LtdParamsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "augmintTokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "newAcceptedState",
    type: "bool"
  }],
  name: "AcceptedLegacyAugmintTokenChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "oldTokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "account",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "LegacyTokenConverted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "totalLoanAmountAdjustment",
    type: "uint256"
  }, {
    indexed: false,
    name: "totalLockedAmountAdjustment",
    type: "uint256"
  }],
  name: "KPIsAdjusted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newInterestEarnedAccount",
    type: "address"
  }, {
    indexed: false,
    name: "newAugmintReserves",
    type: "address"
  }],
  name: "SystemContractsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "amount",
    type: "uint256"
  }],
  name: "issueToReserve",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "amount",
    type: "uint256"
  }],
  name: "burnFromReserve",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "amountToLock",
    type: "uint256"
  }, {
    name: "interestAmount",
    type: "uint256"
  }],
  name: "requestInterest",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockedAmount",
    type: "uint256"
  }],
  name: "releaseFundsNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "borrower",
    type: "address"
  }, {
    name: "loanAmount",
    type: "uint256"
  }],
  name: "issueLoan",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "loanAmount",
    type: "uint256"
  }],
  name: "loanRepaymentNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "totalLoanAmountCollected",
    type: "uint256"
  }],
  name: "loanCollectionNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "legacyAugmintTokenAddress",
    type: "address"
  }, {
    name: "newAcceptedState",
    type: "bool"
  }],
  name: "setAcceptedLegacyAugmintToken",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  name: "setLtdParams",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "totalLoanAmountAdjustment",
    type: "uint256"
  }, {
    name: "totalLockedAmountAdjustment",
    type: "uint256"
  }],
  name: "adjustKPIs",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newInterestEarnedAccount",
    type: "address"
  }, {
    name: "newAugmintReserves",
    type: "address"
  }],
  name: "setSystemContracts",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getLoanToDepositRatio",
  outputs: [{
    name: "loanToDepositRatio",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "minLockAmount",
    type: "uint256"
  }, {
    name: "interestPt",
    type: "uint256"
  }],
  name: "getMaxLockAmount",
  outputs: [{
    name: "maxLock",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "minLoanAmount",
    type: "uint256"
  }],
  name: "getMaxLoanAmount",
  outputs: [{
    name: "maxLoan",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getMaxLockAmountAllowedByLtd",
  outputs: [{
    name: "maxLockByLtd",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getMaxLoanAmountAllowedByLtd",
  outputs: [{
    name: "maxLoanByLtd",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd = [{
  constant: true,
  inputs: [],
  name: "totalLockedAmount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "ltdParams",
  outputs: [{
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "burnedByStabilityBoard",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalLoanAmount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "interestEarnedAccount",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "issuedByStabilityBoard",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintToken",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "PERCENT_100",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "acceptedLegacyAugmintTokens",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "augmintReserves",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }, {
    name: "_augmintToken",
    type: "address"
  }, {
    name: "_augmintReserves",
    type: "address"
  }, {
    name: "_interestEarnedAccount",
    type: "address"
  }, {
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    indexed: false,
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    indexed: false,
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  name: "LtdParamsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "augmintTokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "newAcceptedState",
    type: "bool"
  }],
  name: "AcceptedLegacyAugmintTokenChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "oldTokenAddress",
    type: "address"
  }, {
    indexed: false,
    name: "account",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "LegacyTokenConverted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "totalLoanAmountAdjustment",
    type: "uint256"
  }, {
    indexed: false,
    name: "totalLockedAmountAdjustment",
    type: "uint256"
  }],
  name: "KPIsAdjusted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newInterestEarnedAccount",
    type: "address"
  }, {
    indexed: false,
    name: "newAugmintReserves",
    type: "address"
  }],
  name: "SystemContractsChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "amount",
    type: "uint256"
  }],
  name: "issueToReserve",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "amount",
    type: "uint256"
  }],
  name: "burnFromReserve",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "amountToLock",
    type: "uint256"
  }, {
    name: "interestAmount",
    type: "uint256"
  }],
  name: "requestInterest",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockedAmount",
    type: "uint256"
  }],
  name: "releaseFundsNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "borrower",
    type: "address"
  }, {
    name: "loanAmount",
    type: "uint256"
  }],
  name: "issueLoan",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "loanAmount",
    type: "uint256"
  }],
  name: "loanRepaymentNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "totalLoanAmountCollected",
    type: "uint256"
  }],
  name: "loanCollectionNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "legacyAugmintTokenAddress",
    type: "address"
  }, {
    name: "newAcceptedState",
    type: "bool"
  }],
  name: "setAcceptedLegacyAugmintToken",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "lockDifferenceLimit",
    type: "uint256"
  }, {
    name: "loanDifferenceLimit",
    type: "uint256"
  }, {
    name: "allowedDifferenceAmount",
    type: "uint256"
  }],
  name: "setLtdParams",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "totalLoanAmountAdjustment",
    type: "uint256"
  }, {
    name: "totalLockedAmountAdjustment",
    type: "uint256"
  }],
  name: "adjustKPIs",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newInterestEarnedAccount",
    type: "address"
  }, {
    name: "newAugmintReserves",
    type: "address"
  }],
  name: "setSystemContracts",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "",
    type: "uint256"
  }],
  name: "transferNotification",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "minLockAmount",
    type: "uint256"
  }, {
    name: "interestPt",
    type: "uint256"
  }],
  name: "getMaxLockAmount",
  outputs: [{
    name: "maxLock",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "minLoanAmount",
    type: "uint256"
  }],
  name: "getMaxLoanAmount",
  outputs: [{
    name: "maxLoan",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getMaxLockAmountAllowedByLtd",
  outputs: [{
    name: "maxLockByLtd",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getMaxLoanAmountAllowedByLtd",
  outputs: [{
    name: "maxLoanByLtd",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var PreToken_ABI_10eebbb51a771cfd3473475169a569f1 = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allAgreements",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "agreementOwners",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "bytes32"
  }],
  name: "agreements",
  outputs: [{
    name: "owner",
    type: "address"
  }, {
    name: "balance",
    type: "uint256"
  }, {
    name: "discount",
    type: "uint32"
  }, {
    name: "valuationCap",
    type: "uint32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    name: "agreementHash",
    type: "bytes32"
  }, {
    indexed: false,
    name: "discount",
    type: "uint32"
  }, {
    indexed: false,
    name: "valuationCap",
    type: "uint32"
  }],
  name: "NewAgreement",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "owner",
    type: "address"
  }, {
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "discount",
    type: "uint32"
  }, {
    name: "valuationCap",
    type: "uint32"
  }],
  name: "addAgreement",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "issueTo",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "burnFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "to",
    type: "address"
  }],
  name: "transferAgreement",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAgreementsCount",
  outputs: [{
    name: "agreementsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getAllAgreements",
  outputs: [{
    name: "agreementsResult",
    type: "uint256[6][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var PreToken_ABI_7f69e33e7b345c780ac9e43f391437d9 = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allAgreements",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "agreementOwners",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "bytes32"
  }],
  name: "agreements",
  outputs: [{
    name: "owner",
    type: "address"
  }, {
    name: "balance",
    type: "uint256"
  }, {
    name: "discount",
    type: "uint32"
  }, {
    name: "valuationCap",
    type: "uint32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "owner",
    type: "address"
  }, {
    indexed: false,
    name: "agreementHash",
    type: "bytes32"
  }, {
    indexed: false,
    name: "discount",
    type: "uint32"
  }, {
    indexed: false,
    name: "valuationCap",
    type: "uint32"
  }],
  name: "NewAgreement",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "owner",
    type: "address"
  }, {
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "discount",
    type: "uint32"
  }, {
    name: "valuationCap",
    type: "uint32"
  }],
  name: "addAgreement",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "issueTo",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "burnFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agreementHash",
    type: "bytes32"
  }, {
    name: "to",
    type: "address"
  }],
  name: "transferAgreement",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAgreementsCount",
  outputs: [{
    name: "agreementsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getAgreements",
  outputs: [{
    name: "",
    type: "uint256[6][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var PreTokenProxy_ABI_19ab69b650e28b2dd211d3851893f91f = [{
  constant: true,
  inputs: [],
  name: "activeSignersCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "cancelScript",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "execute",
  outputs: [{
    name: "result",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isSigner",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "removeSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getScriptsCount",
  outputs: [{
    name: "scriptsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "scriptAddresses",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getAllSigners",
  outputs: [{
    name: "signersResult",
    type: "uint256[3][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getAllScripts",
  outputs: [{
    name: "scriptsResult",
    type: "uint256[4][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "scripts",
  outputs: [{
    name: "state",
    type: "uint8"
  }, {
    name: "signCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAllSignersCount",
  outputs: [{
    name: "allSignersCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allSigners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "addSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "sign",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerRemoved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "ScriptSigned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptApproved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptCancelled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "result",
    type: "bool"
  }],
  name: "ScriptExecuted",
  type: "event"
}];
var PreTokenProxy_ABI_875b3d71bd113c550827112698f839cd = [{
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getSigners",
  outputs: [{
    name: "",
    type: "uint256[3][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getScripts",
  outputs: [{
    name: "",
    type: "uint256[4][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "activeSignersCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "cancelScript",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "execute",
  outputs: [{
    name: "result",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isSigner",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "removeSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getScriptsCount",
  outputs: [{
    name: "scriptsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "scriptAddresses",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "scripts",
  outputs: [{
    name: "state",
    type: "uint8"
  }, {
    name: "signCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAllSignersCount",
  outputs: [{
    name: "allSignersCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allSigners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "dryExecute",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "addSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "sign",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerRemoved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "ScriptSigned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptApproved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptCancelled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "result",
    type: "bool"
  }],
  name: "ScriptExecuted",
  type: "event"
}];
var PreTokenProxy_ABI_dd40c0d39ea8bad8a388522667a84687 = [{
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getSigners",
  outputs: [{
    name: "",
    type: "uint256[3][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getScripts",
  outputs: [{
    name: "",
    type: "uint256[4][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "activeSignersCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "cancelScript",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "execute",
  outputs: [{
    name: "result",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isSigner",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "removeSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getScriptsCount",
  outputs: [{
    name: "scriptsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "scriptAddresses",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "scripts",
  outputs: [{
    name: "state",
    type: "uint8"
  }, {
    name: "signCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAllSignersCount",
  outputs: [{
    name: "allSignersCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allSigners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "addSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "sign",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerRemoved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "ScriptSigned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptApproved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptCancelled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "result",
    type: "bool"
  }],
  name: "ScriptExecuted",
  type: "event"
}];
var Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce = [{
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "bytes32"
  }],
  name: "rates",
  outputs: [{
    name: "rate",
    type: "uint256"
  }, {
    name: "lastUpdated",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "permissionGranterContract",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "symbol",
    type: "bytes32"
  }, {
    indexed: false,
    name: "newRate",
    type: "uint256"
  }],
  name: "RateChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}, {
  constant: false,
  inputs: [{
    name: "symbol",
    type: "bytes32"
  }, {
    name: "newRate",
    type: "uint256"
  }],
  name: "setRate",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "symbols",
    type: "bytes32[]"
  }, {
    name: "newRates",
    type: "uint256[]"
  }],
  name: "setMultipleRates",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "bSymbol",
    type: "bytes32"
  }, {
    name: "weiValue",
    type: "uint256"
  }],
  name: "convertFromWei",
  outputs: [{
    name: "value",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "bSymbol",
    type: "bytes32"
  }, {
    name: "value",
    type: "uint256"
  }],
  name: "convertToWei",
  outputs: [{
    name: "weiValue",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}];
var StabilityBoardProxy_ABI_19ab69b650e28b2dd211d3851893f91f = [{
  constant: true,
  inputs: [],
  name: "activeSignersCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "cancelScript",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "execute",
  outputs: [{
    name: "result",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isSigner",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "removeSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getScriptsCount",
  outputs: [{
    name: "scriptsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "scriptAddresses",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getAllSigners",
  outputs: [{
    name: "signersResult",
    type: "uint256[3][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }],
  name: "getAllScripts",
  outputs: [{
    name: "scriptsResult",
    type: "uint256[4][100]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "scripts",
  outputs: [{
    name: "state",
    type: "uint8"
  }, {
    name: "signCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAllSignersCount",
  outputs: [{
    name: "allSignersCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allSigners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "addSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "CHUNK_SIZE",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "sign",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerRemoved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "ScriptSigned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptApproved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptCancelled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "result",
    type: "bool"
  }],
  name: "ScriptExecuted",
  type: "event"
}];
var StabilityBoardProxy_ABI_875b3d71bd113c550827112698f839cd = [{
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getSigners",
  outputs: [{
    name: "",
    type: "uint256[3][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getScripts",
  outputs: [{
    name: "",
    type: "uint256[4][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "activeSignersCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "cancelScript",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "execute",
  outputs: [{
    name: "result",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isSigner",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "removeSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getScriptsCount",
  outputs: [{
    name: "scriptsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "scriptAddresses",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "scripts",
  outputs: [{
    name: "state",
    type: "uint8"
  }, {
    name: "signCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAllSignersCount",
  outputs: [{
    name: "allSignersCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allSigners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "dryExecute",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "addSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "sign",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerRemoved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "ScriptSigned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptApproved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptCancelled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "result",
    type: "bool"
  }],
  name: "ScriptExecuted",
  type: "event"
}];
var StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687 = [{
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getSigners",
  outputs: [{
    name: "",
    type: "uint256[3][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "offset",
    type: "uint256"
  }, {
    name: "chunkSize",
    type: "uint16"
  }],
  name: "getScripts",
  outputs: [{
    name: "",
    type: "uint256[4][]"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "activeSignersCount",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "cancelScript",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "execute",
  outputs: [{
    name: "result",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isSigner",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "removeSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getScriptsCount",
  outputs: [{
    name: "scriptsCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "scriptAddresses",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "scripts",
  outputs: [{
    name: "state",
    type: "uint8"
  }, {
    name: "signCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "getAllSignersCount",
  outputs: [{
    name: "allSignersCount",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "uint256"
  }],
  name: "allSigners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "signers",
    type: "address[]"
  }],
  name: "addSigners",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "scriptAddress",
    type: "address"
  }],
  name: "sign",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerAdded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "SignerRemoved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "signer",
    type: "address"
  }],
  name: "ScriptSigned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptApproved",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }],
  name: "ScriptCancelled",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "scriptAddress",
    type: "address"
  }, {
    indexed: false,
    name: "result",
    type: "bool"
  }],
  name: "ScriptExecuted",
  type: "event"
}];
var TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5 = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "target",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "data",
    type: "uint256"
  }],
  name: "transferAndNotify",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "issueTo",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "balances",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "peggedSymbol",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "amount",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newFeeAccount",
    type: "address"
  }],
  name: "setFeeAccount",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "address"
  }],
  name: "allowed",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "feeAccount",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "_subtractedValue",
    type: "uint256"
  }],
  name: "decreaseApproval",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "balance",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "transferFromWithNarrative",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }, {
    name: "maxExecutorFeeInToken",
    type: "uint256"
  }, {
    name: "nonce",
    type: "bytes32"
  }, {
    name: "signature",
    type: "bytes"
  }, {
    name: "requestedExecutorFeeInToken",
    type: "uint256"
  }],
  name: "delegatedTransfer",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_symbol",
    type: "string"
  }],
  name: "setSymbol",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_name",
    type: "string"
  }],
  name: "setName",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "target",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "data",
    type: "uint256"
  }, {
    name: "maxExecutorFeeInToken",
    type: "uint256"
  }, {
    name: "nonce",
    type: "bytes32"
  }, {
    name: "signature",
    type: "bytes"
  }, {
    name: "requestedExecutorFeeInToken",
    type: "uint256"
  }],
  name: "delegatedTransferAndNotify",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "_addedValue",
    type: "uint256"
  }],
  name: "increaseApproval",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address"
  }, {
    name: "_spender",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    name: "remaining",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "bytes32"
  }],
  name: "delegatedTxHashesUsed",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "transferWithNarrative",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "_permissionGranterContract",
    type: "address"
  }, {
    name: "_feeAccount",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newFeeAccount",
    type: "address"
  }],
  name: "FeeAccountChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "transferFeePt",
    type: "uint256"
  }, {
    indexed: false,
    name: "transferFeeMin",
    type: "uint256"
  }, {
    indexed: false,
    name: "transferFeeMax",
    type: "uint256"
  }],
  name: "TransferFeesChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }, {
    indexed: false,
    name: "narrative",
    type: "string"
  }, {
    indexed: false,
    name: "fee",
    type: "uint256"
  }],
  name: "AugmintTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "TokenIssued",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "TokenBurned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "_owner",
    type: "address"
  }, {
    indexed: true,
    name: "_spender",
    type: "address"
  }, {
    indexed: false,
    name: "_value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}];
var TokenAEur_ABI_9aa81519ec45a52d3f8f1a1a83d25c74 = [{
  constant: true,
  inputs: [],
  name: "name",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "approve",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "target",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "data",
    type: "uint256"
  }],
  name: "transferAndNotify",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "issueTo",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "totalSupply",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "balances",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "decimals",
  outputs: [{
    name: "",
    type: "uint8"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "peggedSymbol",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "stabilityBoardProxy",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "amount",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "newFeeAccount",
    type: "address"
  }],
  name: "setFeeAccount",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }],
  name: "permissions",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "address"
  }],
  name: "allowed",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "revokePermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "feeAccount",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "_subtractedValue",
    type: "uint256"
  }],
  name: "decreaseApproval",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    name: "balance",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "transferFromWithNarrative",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "revokeMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [],
  name: "symbol",
  outputs: [{
    name: "",
    type: "string"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermissions",
    type: "bytes32[]"
  }],
  name: "grantMultiplePermissions",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  name: "transfer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }, {
    name: "maxExecutorFeeInToken",
    type: "uint256"
  }, {
    name: "nonce",
    type: "bytes32"
  }, {
    name: "signature",
    type: "bytes"
  }, {
    name: "requestedExecutorFeeInToken",
    type: "uint256"
  }],
  name: "delegatedTransfer",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "from",
    type: "address"
  }, {
    name: "target",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "data",
    type: "uint256"
  }, {
    name: "maxExecutorFeeInToken",
    type: "uint256"
  }, {
    name: "nonce",
    type: "bytes32"
  }, {
    name: "signature",
    type: "bytes"
  }, {
    name: "requestedExecutorFeeInToken",
    type: "uint256"
  }],
  name: "delegatedTransferAndNotify",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "_spender",
    type: "address"
  }, {
    name: "_addedValue",
    type: "uint256"
  }],
  name: "increaseApproval",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address"
  }, {
    name: "_spender",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    name: "remaining",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "bytes32"
  }],
  name: "delegatedTxHashesUsed",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "agent",
    type: "address"
  }, {
    name: "requiredPermission",
    type: "bytes32"
  }],
  name: "grantPermission",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: false,
  inputs: [{
    name: "to",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }, {
    name: "narrative",
    type: "string"
  }],
  name: "transferWithNarrative",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    name: "_permissionGranterContract",
    type: "address"
  }, {
    name: "_feeAccount",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "newFeeAccount",
    type: "address"
  }],
  name: "FeeAccountChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "transferFeePt",
    type: "uint256"
  }, {
    indexed: false,
    name: "transferFeeMin",
    type: "uint256"
  }, {
    indexed: false,
    name: "transferFeeMax",
    type: "uint256"
  }],
  name: "TransferFeesChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "amount",
    type: "uint256"
  }, {
    indexed: false,
    name: "narrative",
    type: "string"
  }, {
    indexed: false,
    name: "fee",
    type: "uint256"
  }],
  name: "AugmintTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "TokenIssued",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    name: "amount",
    type: "uint256"
  }],
  name: "TokenBurned",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "_owner",
    type: "address"
  }, {
    indexed: true,
    name: "_spender",
    type: "address"
  }, {
    indexed: false,
    name: "_value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "grantedPermission",
    type: "bytes32"
  }],
  name: "PermissionGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "agent",
    type: "address"
  }, {
    indexed: false,
    name: "revokedPermission",
    type: "bytes32"
  }],
  name: "PermissionRevoked",
  type: "event"
}];
var AbiList =
/*#__PURE__*/
Object.freeze({
  AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f: AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f,
  AugmintReserves_ABI_fe74b7986dafb00f221486e790fc70ec: AugmintReserves_ABI_fe74b7986dafb00f221486e790fc70ec,
  Exchange_ABI_b2a23202a9a0f04755a186896c2b56eb: Exchange_ABI_b2a23202a9a0f04755a186896c2b56eb,
  Exchange_ABI_c28de2392aea85ef2aa1b108fce6568c: Exchange_ABI_c28de2392aea85ef2aa1b108fce6568c,
  Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd: Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd,
  FeeAccount_ABI_67db260db12738df3cced3511d34c65c: FeeAccount_ABI_67db260db12738df3cced3511d34c65c,
  InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f: InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f,
  LoanManager_ABI_753a73f4b2140507197a8f80bff47b40: LoanManager_ABI_753a73f4b2140507197a8f80bff47b40,
  LoanManager_ABI_ec709c3341045caa3a75374b8cfc7286: LoanManager_ABI_ec709c3341045caa3a75374b8cfc7286,
  LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb: LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb,
  Locker_ABI_619ff7809b73aead28176fe6317953c3: Locker_ABI_619ff7809b73aead28176fe6317953c3,
  Locker_ABI_f59526398823aef0f0c1454d0b6b4eac: Locker_ABI_f59526398823aef0f0c1454d0b6b4eac,
  Migrations_ABI_78141a323f4a8416891b06a0a2b90065: Migrations_ABI_78141a323f4a8416891b06a0a2b90065,
  MonetarySupervisor_ABI_54d27fedd8bf3010ad5509866a42c053: MonetarySupervisor_ABI_54d27fedd8bf3010ad5509866a42c053,
  MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd: MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd,
  PreToken_ABI_10eebbb51a771cfd3473475169a569f1: PreToken_ABI_10eebbb51a771cfd3473475169a569f1,
  PreToken_ABI_7f69e33e7b345c780ac9e43f391437d9: PreToken_ABI_7f69e33e7b345c780ac9e43f391437d9,
  PreTokenProxy_ABI_19ab69b650e28b2dd211d3851893f91f: PreTokenProxy_ABI_19ab69b650e28b2dd211d3851893f91f,
  PreTokenProxy_ABI_875b3d71bd113c550827112698f839cd: PreTokenProxy_ABI_875b3d71bd113c550827112698f839cd,
  PreTokenProxy_ABI_dd40c0d39ea8bad8a388522667a84687: PreTokenProxy_ABI_dd40c0d39ea8bad8a388522667a84687,
  Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce: Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce,
  StabilityBoardProxy_ABI_19ab69b650e28b2dd211d3851893f91f: StabilityBoardProxy_ABI_19ab69b650e28b2dd211d3851893f91f,
  StabilityBoardProxy_ABI_875b3d71bd113c550827112698f839cd: StabilityBoardProxy_ABI_875b3d71bd113c550827112698f839cd,
  StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687: StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687,
  TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5: TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5,
  TokenAEur_ABI_9aa81519ec45a52d3f8f1a1a83d25c74: TokenAEur_ABI_9aa81519ec45a52d3f8f1a1a83d25c74
});
var connectedInstances = new Map();

var DeployedContract =
/*#__PURE__*/
function () {
  function DeployedContract(deployedItem) {
    _classCallCheck(this, DeployedContract);

    this.abiFileName = deployedItem.abiFileName;
    this.deployedAddress = deployedItem.deployedAddress;
  }

  _createClass(DeployedContract, [{
    key: "connect",
    value: function connect(web3) {
      var connectedInstance = connectedInstances.get(this.instanceHash);

      if (!connectedInstance) {
        connectedInstance = this.connectToAddress(web3, this.deployedAddress);
        connectedInstances.set(this.instanceHash, connectedInstance);
      }

      return connectedInstance;
    }
  }, {
    key: "connectToAddress",
    value: function connectToAddress(web3, address) {
      var abiFile = AbiList[this.abiFileName];
      return new web3.eth.Contract(abiFile, address);
    }
  }, {
    key: "connectWithEthers",
    value: function connectWithEthers(ethers, provider) {
      var abiFile = AbiList[this.abiFileName];
      return new ethers.Contract(this.deployedAddress, abiFile, provider);
    }
  }, {
    key: "instanceHash",
    get: function get() {
      return "".concat(this.abiFileName, "_").concat(this.deployedAddress);
    }
  }]);

  return DeployedContract;
}();

var DeployedEnvironment =
/*#__PURE__*/
function () {
  function DeployedEnvironment(name) {
    _classCallCheck(this, DeployedEnvironment);

    this.name = name;
    this.contracts = {};
  }

  _createClass(DeployedEnvironment, [{
    key: "addRole",
    value: function addRole(role, contractList) {
      this.contracts[role] = contractList;
    }
  }, {
    key: "getRole",
    value: function getRole(role) {
      return this.contracts[role];
    }
  }, {
    key: "getLatestContracts",
    value: function getLatestContracts() {
      var _this = this;

      var latestContracts = {};
      Object.keys(this.contracts).forEach(function (contractName) {
        latestContracts[contractName] = _this.contracts[contractName][0];
      });
      return latestContracts;
    }
  }, {
    key: "getLatestContract",
    value: function getLatestContract(name) {
      var contractList = this.contracts[name];
      return contractList[0];
    }
  }, {
    key: "getLegacyContracts",
    value: function getLegacyContracts(name) {
      var contractList = this.contracts[name];
      return contractList.slice(1);
    }
  }, {
    key: "getContractFromAddresses",
    value: function getContractFromAddresses(name, _addresses) {
      var contractList = this.contracts[name];

      var addresses = _addresses.map(function (addr) {
        return addr.toLowerCase();
      });

      return contractList.filter(function (contract) {
        return addresses.indexOf(contract.deployedAddress.toLowerCase()) > -1;
      });
    }
  }, {
    key: "getContractFromAddress",
    value: function getContractFromAddress(name, address) {
      var contract = this.getContract(name, address);

      if (!contract) {
        throw new Error("missing contract: did not find " + name + " at " + address);
      }

      return contract;
    }
  }, {
    key: "getAbiHash",
    value: function getAbiHash(name, address) {
      var contract = this.getContract(name, address);
      return contract && contract.abiFileName.split('_').pop();
    }
  }, {
    key: "getContract",
    value: function getContract(name, address) {
      var contracts = this.contracts[name];
      return contracts && contracts.find(function (item) {
        return item.deployedAddress.toLowerCase() === address.toLowerCase();
      });
    }
  }]);

  return DeployedEnvironment;
}();
/* Generated by ts-generator ver. 0.0.8 */


var deployedEnvironments = [];
var currentEnvironment;
currentEnvironment = new DeployedEnvironment("1");
deployedEnvironments.push(currentEnvironment);
currentEnvironment.addRole("AugmintReserves", [new DeployedContract({
  abiFileName: "AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f",
  deployedAddress: "0x65f30f8dd20c707c1938ccad7416c7381e6eb9c8"
}), new DeployedContract({
  abiFileName: "AugmintReserves_ABI_fe74b7986dafb00f221486e790fc70ec",
  deployedAddress: "0x633cb544b2ef1bd9269b2111fd2b66fc05cd3477"
})]);
currentEnvironment.addRole("Exchange", [new DeployedContract({
  abiFileName: "Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd",
  deployedAddress: "0xc670ffbfa21c37481fb4ef2ea2249b9b78d2b073"
}), new DeployedContract({
  abiFileName: "Exchange_ABI_c28de2392aea85ef2aa1b108fce6568c",
  deployedAddress: "0xafea54badf7a68f93c2235b5f4cc8f02a2b55edd"
}), new DeployedContract({
  abiFileName: "Exchange_ABI_c28de2392aea85ef2aa1b108fce6568c",
  deployedAddress: "0xeae7d30bcd44f27d58985b56add007fcee254abd"
}), new DeployedContract({
  abiFileName: "Exchange_ABI_b2a23202a9a0f04755a186896c2b56eb",
  deployedAddress: "0x8b52b019d237d0bbe8baedf219132d5254e0690b"
})]);
currentEnvironment.addRole("FeeAccount", [new DeployedContract({
  abiFileName: "FeeAccount_ABI_67db260db12738df3cced3511d34c65c",
  deployedAddress: "0xe3ed84a163b9eeaf4f69b4890ae45cc52171aa7e"
}), new DeployedContract({
  abiFileName: "FeeAccount_ABI_67db260db12738df3cced3511d34c65c",
  deployedAddress: "0xf6b541e1b5e001dcc11827c1a16232759aea730a"
})]);
currentEnvironment.addRole("InterestEarnedAccount", [new DeployedContract({
  abiFileName: "InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f",
  deployedAddress: "0xf23e0af0e41341127bb4e7b203aebca0185f9ebd"
}), new DeployedContract({
  abiFileName: "InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f",
  deployedAddress: "0x5c1a44e07541203474d92bdd03f803ea74f6947c"
})]);
currentEnvironment.addRole("LoanManager", [new DeployedContract({
  abiFileName: "LoanManager_ABI_753a73f4b2140507197a8f80bff47b40",
  deployedAddress: "0xeb57c12b1e69b4d10b1ed7a33231d31b811464b7"
}), new DeployedContract({
  abiFileName: "LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb",
  deployedAddress: "0x1cabc34618ecf2949f0405a86353e7705e01c38b"
}), new DeployedContract({
  abiFileName: "LoanManager_ABI_ec709c3341045caa3a75374b8cfc7286",
  deployedAddress: "0xcbefaf199b800deeb9ead61f358ee46e06c54070"
})]);
currentEnvironment.addRole("Locker", [new DeployedContract({
  abiFileName: "Locker_ABI_f59526398823aef0f0c1454d0b6b4eac",
  deployedAddress: "0x5cc161482e82f20840a4aaeb582becbcc4b539d7"
}), new DeployedContract({
  abiFileName: "Locker_ABI_619ff7809b73aead28176fe6317953c3",
  deployedAddress: "0x26438d7c52ce617dfc75a2f02ee816557f01e5bb"
}), new DeployedContract({
  abiFileName: "Locker_ABI_619ff7809b73aead28176fe6317953c3",
  deployedAddress: "0x095c0f071fd75875a6b5a1def3f3a993f591080c"
})]);
currentEnvironment.addRole("Migrations", [new DeployedContract({
  abiFileName: "Migrations_ABI_78141a323f4a8416891b06a0a2b90065",
  deployedAddress: "0xf01c976e9189bc9ba68eda0f1dc9d94b243c78dc"
}), new DeployedContract({
  abiFileName: "Migrations_ABI_78141a323f4a8416891b06a0a2b90065",
  deployedAddress: "0xe7e9f87805c0bec5108963d07f85e4ca5892d421"
})]);
currentEnvironment.addRole("MonetarySupervisor", [new DeployedContract({
  abiFileName: "MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd",
  deployedAddress: "0x27484afe9e6c332fb07f21fac82d442ebe1d22c3"
}), new DeployedContract({
  abiFileName: "MonetarySupervisor_ABI_54d27fedd8bf3010ad5509866a42c053",
  deployedAddress: "0x1ca4f9d261707af8a856020a4909b777da218868"
})]);
currentEnvironment.addRole("PreToken", [new DeployedContract({
  abiFileName: "PreToken_ABI_7f69e33e7b345c780ac9e43f391437d9",
  deployedAddress: "0x97ea02179801fa94227db5fc1d13ac4277d40920"
}), new DeployedContract({
  abiFileName: "PreToken_ABI_10eebbb51a771cfd3473475169a569f1",
  deployedAddress: "0xecb782b19be6e657ae2d88831dd98145a00d32d5"
})]);
currentEnvironment.addRole("PreTokenProxy", [new DeployedContract({
  abiFileName: "PreTokenProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0x8a69cf9d1d85bc150f69feb80cc34c552f5fbea9"
}), new DeployedContract({
  abiFileName: "PreTokenProxy_ABI_19ab69b650e28b2dd211d3851893f91f",
  deployedAddress: "0x1411b3b189b01f6e6d1ea883bffcbd3a5224934c"
})]);
currentEnvironment.addRole("Rates", [new DeployedContract({
  abiFileName: "Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce",
  deployedAddress: "0x4272db2eb82068e898588c3d6e4b5d55c3848793"
}), new DeployedContract({
  abiFileName: "Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce",
  deployedAddress: "0x4babbe57453e2b6af125b4e304256fcbdf744480"
})]);
currentEnvironment.addRole("StabilityBoardProxy", [new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0xde36a8773531406dcbeffdfd3c7b89fced7a9f84"
}), new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_19ab69b650e28b2dd211d3851893f91f",
  deployedAddress: "0x4686f017d456331ed2c1de66e134d8d05b24413d"
})]);
currentEnvironment.addRole("TokenAEur", [new DeployedContract({
  abiFileName: "TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5",
  deployedAddress: "0xc994a2deb02543db1f48688438b9903c4b305ce3"
}), new DeployedContract({
  abiFileName: "TokenAEur_ABI_9aa81519ec45a52d3f8f1a1a83d25c74",
  deployedAddress: "0x86a635eccefffa70ff8a6db29da9c8db288e40d0"
})]);
currentEnvironment = new DeployedEnvironment("4");
deployedEnvironments.push(currentEnvironment);
currentEnvironment.addRole("AugmintReserves", [new DeployedContract({
  abiFileName: "AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f",
  deployedAddress: "0x33bec125657470e53887400666bdeed360b2168a"
}), new DeployedContract({
  abiFileName: "AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f",
  deployedAddress: "0xc036a1dd59ac55e2fb6b3d7416cb4ecc44605834"
})]);
currentEnvironment.addRole("Exchange", [new DeployedContract({
  abiFileName: "Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd",
  deployedAddress: "0xe5d6d0c107eae79d2d30798f252ac6ff5ecad459"
}), new DeployedContract({
  abiFileName: "Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd",
  deployedAddress: "0xdf47d51028daff13424f42523fdac73079ab901b"
})]);
currentEnvironment.addRole("FeeAccount", [new DeployedContract({
  abiFileName: "FeeAccount_ABI_67db260db12738df3cced3511d34c65c",
  deployedAddress: "0xaa16ede9093bb4140e2715ed9a1e41cdfd9d9c29"
}), new DeployedContract({
  abiFileName: "FeeAccount_ABI_67db260db12738df3cced3511d34c65c",
  deployedAddress: "0xb77f9cdda72eec47a57793be088c7b523f6b5014"
})]);
currentEnvironment.addRole("InterestEarnedAccount", [new DeployedContract({
  abiFileName: "InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f",
  deployedAddress: "0xdd96979697b76787b5062084eea60bf929ddd844"
}), new DeployedContract({
  abiFileName: "InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f",
  deployedAddress: "0x489cbf1674b575e6dfcff0a4f2bbc74f7e9dde28"
})]);
currentEnvironment.addRole("LoanManager", [new DeployedContract({
  abiFileName: "LoanManager_ABI_753a73f4b2140507197a8f80bff47b40",
  deployedAddress: "0x99928c5121de38ca6d23c7645cc9697a7263e859"
}), new DeployedContract({
  abiFileName: "LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb",
  deployedAddress: "0x3792c5a5077dacfe331b81837ef73bc0ea721d90"
}), new DeployedContract({
  abiFileName: "LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb",
  deployedAddress: "0x6cb7731c78e677f85942b5f1d646b3485e5820c1"
})]);
currentEnvironment.addRole("Locker", [new DeployedContract({
  abiFileName: "Locker_ABI_f59526398823aef0f0c1454d0b6b4eac",
  deployedAddress: "0xc0b97fe5cad0d43d0c974c4e9a00312dc661f8ab"
}), new DeployedContract({
  abiFileName: "Locker_ABI_f59526398823aef0f0c1454d0b6b4eac",
  deployedAddress: "0x6d84ab6c385b827e58c358d078ac7b1c61b68821"
})]);
currentEnvironment.addRole("Migrations", [new DeployedContract({
  abiFileName: "Migrations_ABI_78141a323f4a8416891b06a0a2b90065",
  deployedAddress: "0xc9a7258b2b1ea36ce735793e4816ad949532c9fd"
})]);
currentEnvironment.addRole("MonetarySupervisor", [new DeployedContract({
  abiFileName: "MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd",
  deployedAddress: "0x4a7f6ecbe8b324a55b85adcc45313a412957b8ea"
}), new DeployedContract({
  abiFileName: "MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd",
  deployedAddress: "0xcec3574eca89409b15a8a72a6e737c4171457871"
})]);
currentEnvironment.addRole("PreToken", [new DeployedContract({
  abiFileName: "PreToken_ABI_7f69e33e7b345c780ac9e43f391437d9",
  deployedAddress: "0xa7b67e7e3e7f1e76e8d799a690f675abeb85c788"
})]);
currentEnvironment.addRole("PreTokenProxy", [new DeployedContract({
  abiFileName: "PreTokenProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0xb7cae2c48f3f34b9696fd290001dea16b299498a"
})]);
currentEnvironment.addRole("Rates", [new DeployedContract({
  abiFileName: "Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce",
  deployedAddress: "0xee8c7a3e99945a5207dca026504d67527125da9c"
}), new DeployedContract({
  abiFileName: "Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce",
  deployedAddress: "0xdfa3a0aeb9645a55b684cb3ace8c42d018405bda"
})]);
currentEnvironment.addRole("StabilityBoardProxy", [new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_875b3d71bd113c550827112698f839cd",
  deployedAddress: "0x9bb8f0855b8bbaea064bce9b4ef88bc22e649af5"
}), new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0xa612de13b629a1ff790c1f4e41d0422d2bb50a30"
}), new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0x50d281c28846576eaaf679ab6f3baac52b776e72"
})]);
currentEnvironment.addRole("TokenAEur", [new DeployedContract({
  abiFileName: "TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5",
  deployedAddress: "0x79065a165ec09e6a89d584a14872802717fe12a3"
}), new DeployedContract({
  abiFileName: "TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5",
  deployedAddress: "0x0557183334edc23a666201edc6b0aa2787e2ad3f"
})]);
currentEnvironment = new DeployedEnvironment("999");
deployedEnvironments.push(currentEnvironment);
currentEnvironment.addRole("AugmintReserves", [new DeployedContract({
  abiFileName: "AugmintReserves_ABI_024b81d1a1f75241167a8a0f6e62326f",
  deployedAddress: "0x1b9441428f9e682bab4f9cc70fdf50adcc3411f4"
})]);
currentEnvironment.addRole("Exchange", [new DeployedContract({
  abiFileName: "Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd",
  deployedAddress: "0xfacea53a04befcc6c9246eb3951814cfee2a1415"
}), new DeployedContract({
  abiFileName: "Exchange_ABI_d3e7f8a261b756f9c40da097608b21cd",
  deployedAddress: "0xef49d863bd9179da0e96fab02dd498efa149dbdc"
})]);
currentEnvironment.addRole("FeeAccount", [new DeployedContract({
  abiFileName: "FeeAccount_ABI_67db260db12738df3cced3511d34c65c",
  deployedAddress: "0xf5efcaa78f5656f7ddc971bc5d51a08b5f161573"
})]);
currentEnvironment.addRole("InterestEarnedAccount", [new DeployedContract({
  abiFileName: "InterestEarnedAccount_ABI_11b039ce783db308e1a9b5f46f05824f",
  deployedAddress: "0x1efb52b6aacc403cc9d762282b2aec1b066931c5"
})]);
currentEnvironment.addRole("LoanManager", [new DeployedContract({
  abiFileName: "LoanManager_ABI_753a73f4b2140507197a8f80bff47b40",
  deployedAddress: "0x213135c85437c23bc529a2ee9c2980646c332fcb"
}), new DeployedContract({
  abiFileName: "LoanManager_ABI_fdf5fde95aa940c6dbfb8353c572c5fb",
  deployedAddress: "0xf7b8384c392fc333d3858a506c4f1506af44d53c"
})]);
currentEnvironment.addRole("Locker", [new DeployedContract({
  abiFileName: "Locker_ABI_f59526398823aef0f0c1454d0b6b4eac",
  deployedAddress: "0x26b4ababb98fcadd579f28e9c30931bbbe66fc88"
}), new DeployedContract({
  abiFileName: "Locker_ABI_f59526398823aef0f0c1454d0b6b4eac",
  deployedAddress: "0x9f5420ec1348df8de8c85dab8d240ace122204c5"
})]);
currentEnvironment.addRole("Migrations", [new DeployedContract({
  abiFileName: "Migrations_ABI_78141a323f4a8416891b06a0a2b90065",
  deployedAddress: "0xd217ac4354211cda27dd4027b5e223280f885ad3"
})]);
currentEnvironment.addRole("MonetarySupervisor", [new DeployedContract({
  abiFileName: "MonetarySupervisor_ABI_7f500b43397413e97de925528187f9cd",
  deployedAddress: "0x1555469d4a6c063a13ff1e12ca4ab00f5f1b7320"
})]);
currentEnvironment.addRole("PreToken", [new DeployedContract({
  abiFileName: "PreToken_ABI_7f69e33e7b345c780ac9e43f391437d9",
  deployedAddress: "0xbed57eb0b4232da0cddd3c9c27490fc0759e0a01"
})]);
currentEnvironment.addRole("PreTokenProxy", [new DeployedContract({
  abiFileName: "PreTokenProxy_ABI_875b3d71bd113c550827112698f839cd",
  deployedAddress: "0x8b639dc72f3e640c0d6bc19497fbc7b5160d0463"
}), new DeployedContract({
  abiFileName: "PreTokenProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0x8b639dc72f3e640c0d6bc19497fbc7b5160d0463"
})]);
currentEnvironment.addRole("Rates", [new DeployedContract({
  abiFileName: "Rates_ABI_73a17ebb0acc71773371c6a8e1c8e6ce",
  deployedAddress: "0xb0a2a8e846b66c7384f52635cecef5280f766c8b"
})]);
currentEnvironment.addRole("StabilityBoardProxy", [new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_875b3d71bd113c550827112698f839cd",
  deployedAddress: "0xd3ef19679c2dbbf3b8e2077c61b88f5e9c6178eb"
}), new DeployedContract({
  abiFileName: "StabilityBoardProxy_ABI_dd40c0d39ea8bad8a388522667a84687",
  deployedAddress: "0xd3ef19679c2dbbf3b8e2077c61b88f5e9c6178eb"
})]);
currentEnvironment.addRole("TokenAEur", [new DeployedContract({
  abiFileName: "TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5",
  deployedAddress: "0xbbecff5db2f9cccc936895121802fc15053344c6"
}), new DeployedContract({
  abiFileName: "TokenAEur_ABI_2ea91d34a7bfefc8f38ef0e8a5ae24a5",
  deployedAddress: "0x5d77f09a3703be84d84810379067a6d9ad759582"
})]);
/* Generated by ts-generator ver. 0.0.8 */

/* tslint:disable */

var AugmintContracts;

(function (AugmintContracts) {
  AugmintContracts["AugmintReserves"] = "AugmintReserves";
  AugmintContracts["Exchange"] = "Exchange";
  AugmintContracts["FeeAccount"] = "FeeAccount";
  AugmintContracts["InterestEarnedAccount"] = "InterestEarnedAccount";
  AugmintContracts["LoanManager"] = "LoanManager";
  AugmintContracts["Locker"] = "Locker";
  AugmintContracts["Migrations"] = "Migrations";
  AugmintContracts["MonetarySupervisor"] = "MonetarySupervisor";
  AugmintContracts["PreToken"] = "PreToken";
  AugmintContracts["PreTokenProxy"] = "PreTokenProxy";
  AugmintContracts["Rates"] = "Rates";
  AugmintContracts["StabilityBoardProxy"] = "StabilityBoardProxy";
  AugmintContracts["TokenAEur"] = "TokenAEur";
})(AugmintContracts || (AugmintContracts = {}));

var AbstractContract =
/*#__PURE__*/
function () {
  function AbstractContract(instance) {
    _classCallCheck(this, AbstractContract);

    this._address = instance.options.address;
  }

  _createClass(AbstractContract, [{
    key: "address",
    get: function get() {
      return this._address;
    }
  }]);

  return AbstractContract;
}();

var AugmintToken =
/*#__PURE__*/
function (_AbstractContract) {
  _inherits(AugmintToken, _AbstractContract);

  function AugmintToken(deployedContractInstance, ethereumConnection) {
    var _this2;

    _classCallCheck(this, AugmintToken);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AugmintToken).call(this, deployedContractInstance));
    _this2.instance = deployedContractInstance;
    _this2._web3 = ethereumConnection.web3;
    return _this2;
  }

  _createClass(AugmintToken, [{
    key: "peggedSymbol",
    get: function get() {
      var _this3 = this;

      if (!this._peggedSymbol) {
        this._peggedSymbol = this.instance.methods.peggedSymbol().call().then(function (bytes32PeggedSymbol) {
          var peggedSymbolWithTrailing = _this3._web3.utils.toAscii(bytes32PeggedSymbol);

          return peggedSymbolWithTrailing.substr(0, peggedSymbolWithTrailing.indexOf("\0"));
        });
      }

      return this._peggedSymbol;
    }
  }, {
    key: "name",
    get: function get() {
      if (!this._name) {
        this._name = this.instance.methods.name().call();
      }

      return this._name;
    }
  }, {
    key: "symbol",
    get: function get() {
      if (!this._symbol) {
        this._symbol = this.instance.methods.symbol().call();
      }

      return this._symbol;
    }
  }, {
    key: "decimals",
    get: function get() {
      if (!this._decimals) {
        this._decimals = this.instance.methods.decimals().call().then(function (decimals) {
          return parseInt(decimals);
        });
      }

      return this._decimals;
    }
  }, {
    key: "decimalsDiv",
    get: function get() {
      return this.decimals.then(function (decimals) {
        return Math.pow(10, decimals);
      });
    }
  }, {
    key: "feeAccountAddress",
    get: function get() {
      if (!this._feeAccountAddress) {
        this._feeAccountAddress = this.instance.methods.feeAccount().call();
      }

      return this._feeAccountAddress;
    }
  }]);

  return AugmintToken;
}(AbstractContract);

var E12 = new BN("1000000000000");
var BN_ONE = new BN(1);

function ceilDiv(dividend, divisor) {
  return dividend.add(divisor).sub(BN_ONE).div(divisor);
}

var FixedPoint =
/*#__PURE__*/
function () {
  function FixedPoint(amount) {
    _classCallCheck(this, FixedPoint);

    this.amount = amount;

    if (!BN.isBN(amount)) {
      throw new Error("Not a BN: " + amount);
    }
  } //
  // operations
  //


  _createClass(FixedPoint, [{
    key: "add",
    value: function add(other) {
      this.check(other);
      return this.create(this.amount.add(other.amount));
    }
  }, {
    key: "sub",
    value: function sub(other) {
      this.check(other);
      return this.create(this.amount.sub(other.amount));
    } // rounding mode: floor

  }, {
    key: "mul",
    value: function mul(ratio) {
      this.check(ratio, Ratio);
      return this.create(this.amount.mul(ratio.amount).div(Ratio.DIV_BN));
    } // rounding mode: round

  }, {
    key: "mulRound",
    value: function mulRound(ratio) {
      this.check(ratio, Ratio);
      return this.create(this.amount.mul(ratio.amount).divRound(Ratio.DIV_BN));
    } // rounding mode: ceil

  }, {
    key: "mulCeil",
    value: function mulCeil(ratio) {
      this.check(ratio, Ratio);
      return this.create(ceilDiv(this.amount.mul(ratio.amount), Ratio.DIV_BN));
    } // our default div is ceilDiv
    // rounding mode: ceil

  }, {
    key: "div",
    value: function div(ratio) {
      this.check(ratio, Ratio);
      return this.create(ceilDiv(this.amount.mul(Ratio.DIV_BN), ratio.amount));
    } // divFloor uses bignumber's default div (floor)
    // rounding mode: floor

  }, {
    key: "divFloor",
    value: function divFloor(ratio) {
      this.check(ratio, Ratio);
      return this.create(this.amount.mul(Ratio.DIV_BN).div(ratio.amount));
    } // rounding mode: round

  }, {
    key: "divRound",
    value: function divRound(ratio) {
      this.check(ratio, Ratio);
      return this.create(this.amount.mul(Ratio.DIV_BN).divRound(ratio.amount));
    }
  }, {
    key: "divToRatio",
    value: function divToRatio(other) {
      this.check(other);
      return new Ratio(this.amount.mul(Ratio.DIV_BN).divRound(other.amount));
    } //
    // comparison
    //

  }, {
    key: "isZero",
    value: function isZero() {
      return this.amount.isZero();
    }
  }, {
    key: "cmp",
    value: function cmp(other) {
      this.check(other);
      return this.amount.cmp(other.amount);
    }
  }, {
    key: "eq",
    value: function eq(other) {
      this.check(other);
      return this.amount.eq(other.amount);
    }
  }, {
    key: "gte",
    value: function gte(other) {
      this.check(other);
      return this.amount.gte(other.amount);
    }
  }, {
    key: "lte",
    value: function lte(other) {
      this.check(other);
      return this.amount.lte(other.amount);
    } //
    // conversion
    //

  }, {
    key: "zeroToNull",
    value: function zeroToNull() {
      return this.isZero() ? null : this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
  }, {
    key: "toString",
    value: function toString() {
      var radix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      return this.amount.toString(radix);
    } //
    // util
    //

  }, {
    key: "check",
    value: function check(other) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.constructor;

      if (!(other instanceof type)) {
        throw new Error("Type error. Expected " + type + " got " + typeof other);
      }
    }
  }, {
    key: "create",
    value: function create(amount) {
      return new this.constructor(amount);
    }
  }]);

  return FixedPoint;
}();

var Wei =
/*#__PURE__*/
function (_FixedPoint) {
  _inherits(Wei, _FixedPoint);

  function Wei() {
    _classCallCheck(this, Wei);

    return _possibleConstructorReturn(this, _getPrototypeOf(Wei).apply(this, arguments));
  }

  _createClass(Wei, [{
    key: "toTokens",
    value: function toTokens(rate) {
      this.check(rate, Tokens);
      return new Tokens(this.amount.mul(rate.amount).divRound(Wei.DIV_BN));
    }
  }, {
    key: "toTokensAt",
    value: function toTokensAt(rate, price) {
      this.check(rate, Tokens);
      this.check(price, Ratio);
      return new Tokens(this.amount.mul(rate.amount).divRound(price.amount.mul(E12)));
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.amount.divRound(Wei.DIV_PRECISON).toNumber() / Wei.PRECISION;
    }
  }], [{
    key: "parse",
    value: function parse(str) {
      return new Wei(new BN(str.toString()));
    }
  }, {
    key: "of",
    value: function of(num) {
      return new Wei(new BN(Math.round(num * Wei.PRECISION)).mul(Wei.DIV_PRECISON));
    }
  }]);

  return Wei;
}(FixedPoint);

Wei.PRECISION = 1000000;
Wei.DIV_BN = new BN("1000000000000000000");
Wei.DIV_PRECISON = Wei.DIV_BN.divn(Wei.PRECISION);

var Tokens =
/*#__PURE__*/
function (_FixedPoint2) {
  _inherits(Tokens, _FixedPoint2);

  function Tokens() {
    _classCallCheck(this, Tokens);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tokens).apply(this, arguments));
  }

  _createClass(Tokens, [{
    key: "toWei",
    value: function toWei(rate) {
      this.check(rate, Tokens);
      return new Wei(this.amount.mul(Wei.DIV_BN).divRound(rate.amount));
    }
  }, {
    key: "toWeiAt",
    value: function toWeiAt(rate, price) {
      this.check(rate, Tokens);
      this.check(price, Ratio);
      return new Wei(this.amount.mul(price.amount).mul(E12).divRound(rate.amount));
    }
  }, {
    key: "toRate",
    value: function toRate(ethers) {
      this.check(ethers, Wei);
      return new Tokens(this.amount.mul(Wei.DIV_BN).divRound(ethers.amount));
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.amount.toNumber() / Tokens.DIV;
    }
  }], [{
    key: "parse",
    value: function parse(str) {
      return new Tokens(new BN(str.toString()));
    }
  }, {
    key: "of",
    value: function of(num) {
      return new Tokens(new BN(Math.round(num * Tokens.DIV)));
    }
  }, {
    key: "min",
    value: function min(o1, o2) {
      return o1.lte(o2) ? o1 : o2;
    }
  }]);

  return Tokens;
}(FixedPoint);

Tokens.DIV = 100;

var Ratio =
/*#__PURE__*/
function (_FixedPoint3) {
  _inherits(Ratio, _FixedPoint3);

  function Ratio() {
    _classCallCheck(this, Ratio);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ratio).apply(this, arguments));
  }

  _createClass(Ratio, [{
    key: "toNumber",
    value: function toNumber() {
      return this.amount.toNumber() / Ratio.DIV;
    }
  }], [{
    key: "parse",
    value: function parse(str) {
      return new Ratio(new BN(str.toString()));
    }
  }, {
    key: "of",
    value: function of(num) {
      return new Ratio(new BN(Math.round(num * Ratio.DIV)));
    }
  }]);

  return Ratio;
}(FixedPoint);

Ratio.DIV = 1000000;
Ratio.DIV_BN = new BN(Ratio.DIV);
var ETHEUR = "ETHEUR";
/* in legacy contracts CHUNK_SIZE set in contract so don't change this value */

var LEGACY_CONTRACTS_CHUNK_SIZE = 100; // New contracts accept chunksize as param for each fx so it can be adjusted with this constant

var CHUNK_SIZE = 100; // rational: it's to avoid loan tx to fail on min loan amount because of an ETH/EUR rate change
// in the background right while sending the tx

var MIN_LOAN_AMOUNT_ADJUSTMENT = Ratio.of(1.25);
var SUPPORTED_LEGACY_AUGMINTTOKENS = {
  // mainnet
  1: ["0x86a635eccefffa70ff8a6db29da9c8db288e40d0"],
  // local ganache (migrations deploys it for manual testing)
  999: ["0x5d77f09a3703be84d84810379067a6d9ad759582"],
  // rinkeby
  4: ["0x0557183334edc23a666201edc6b0aa2787e2ad3f"]
};
/* List of old augmint Exchange deploy addresses by network id */

var SUPPORTED_LEGACY_EXCHANGES = {
  // mainnet
  1: ["0x8b52b019d237d0bbe8baedf219132D5254e0690b", "0xeae7d30bcd44f27d58985b56add007fcee254abd", "0xafea54badf7a68f93c2235b5f4cc8f02a2b55edd"],
  // local ganache (migrations deploys it for manual testing)
  999: ["0xef49d863bd9179da0e96fab02dd498efa149dbdc"],
  // rinkeby
  4: ["0xdf47d51028daff13424f42523fdac73079ab901b"]
};
/* List of old augmint LoanManager deploy addresses by network id */

var SUPPORTED_LEGACY_LOANMANAGERS = {
  // mainnet
  1: ["0xcbefaf199b800deeb9ead61f358ee46e06c54070"],
  // local ganache (migrations deploys it for manual testing)
  999: ["0xf7b8384c392fc333d3858a506c4f1506af44d53c"],
  // rinkeby
  4: ["0x6cb7731c78e677f85942b5f1d646b3485e5820c1"]
};
var LOAN_STATES;

(function (LOAN_STATES) {
  LOAN_STATES[LOAN_STATES["Open"] = 0] = "Open";
  LOAN_STATES[LOAN_STATES["Repaid"] = 1] = "Repaid";
  LOAN_STATES[LOAN_STATES["Defaulted"] = 2] = "Defaulted";
  LOAN_STATES[LOAN_STATES["Collected"] = 3] = "Collected";
})(LOAN_STATES || (LOAN_STATES = {}));

var constants =
/*#__PURE__*/
Object.freeze({
  ETHEUR: ETHEUR,
  LEGACY_CONTRACTS_CHUNK_SIZE: LEGACY_CONTRACTS_CHUNK_SIZE,
  CHUNK_SIZE: CHUNK_SIZE,
  MIN_LOAN_AMOUNT_ADJUSTMENT: MIN_LOAN_AMOUNT_ADJUSTMENT,
  SUPPORTED_LEGACY_AUGMINTTOKENS: SUPPORTED_LEGACY_AUGMINTTOKENS,
  SUPPORTED_LEGACY_EXCHANGES: SUPPORTED_LEGACY_EXCHANGES,
  SUPPORTED_LEGACY_LOANMANAGERS: SUPPORTED_LEGACY_LOANMANAGERS,

  get LOAN_STATES() {
    return LOAN_STATES;
  }

}); // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work

var AugmintJsError =
/*#__PURE__*/
function (_Error) {
  _inherits(AugmintJsError, _Error);

  function AugmintJsError(message) {
    var _this4;

    _classCallCheck(this, AugmintJsError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(AugmintJsError).call(this, message));
    _this4.name = AugmintJsError.name;
    Object.setPrototypeOf(_assertThisInitialized(_this4), AugmintJsError.prototype);
    return _this4;
  }

  return AugmintJsError;
}(_wrapNativeSuper(Error)); // tslint:disable-next-line:max-classes-per-file


var ZeroRateError =
/*#__PURE__*/
function (_AugmintJsError) {
  _inherits(ZeroRateError, _AugmintJsError);

  function ZeroRateError(message) {
    var _this5;

    _classCallCheck(this, ZeroRateError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ZeroRateError).call(this, message));
    _this5.name = ZeroRateError.name;
    Object.setPrototypeOf(_assertThisInitialized(_this5), ZeroRateError.prototype);
    return _this5;
  }

  return ZeroRateError;
}(AugmintJsError); // tslint:disable-next-line:max-classes-per-file


var TransactionError =
/*#__PURE__*/
function (_AugmintJsError2) {
  _inherits(TransactionError, _AugmintJsError2);

  function TransactionError(message) {
    var _this6;

    _classCallCheck(this, TransactionError);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(TransactionError).call(this, message));
    _this6.name = TransactionError.name;
    Object.setPrototypeOf(_assertThisInitialized(_this6), TransactionError.prototype);
    return _this6;
  }

  return TransactionError;
}(AugmintJsError); // tslint:disable-next-line:max-classes-per-file


var TransactionSendError =
/*#__PURE__*/
function (_TransactionError) {
  _inherits(TransactionSendError, _TransactionError);

  function TransactionSendError(message) {
    var _this7;

    _classCallCheck(this, TransactionSendError);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(TransactionSendError).call(this, message));
    _this7.name = TransactionSendError.name;
    Object.setPrototypeOf(_assertThisInitialized(_this7), TransactionSendError.prototype);
    return _this7;
  }

  return TransactionSendError;
}(TransactionError);

var Errors =
/*#__PURE__*/
Object.freeze({
  AugmintJsError: AugmintJsError,
  ZeroRateError: ZeroRateError,
  TransactionError: TransactionError,
  TransactionSendError: TransactionSendError
});

function promiseTimeout(ms, promise) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var id, timeout;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeout = new Promise(function (resolve, reject) {
              id = setTimeout(function () {
                reject("Timed out in " + ms + "ms.");
              }, ms);
            });
            return _context.abrupt("return", Promise.race([promise, timeout]).then(function (result) {
              clearTimeout(id);
              return result;
            }).catch(function (error) {
              clearTimeout(id);
              throw error;
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

var DEFAULT_EXIT_TIMEOUT = 10000; // how much to wait before timing out disconnect (in ms)

var SIGNALS = ["SIGINT", "SIGQUIT", "SIGTERM"];
var log = logger("sigintHandler");

function setExitHandler(exitHandlerCb, name) {
  var _this8 = this;

  var exitTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_EXIT_TIMEOUT;
  SIGNALS.forEach(function (signal) {
    process.on(signal, function (_signal) {
      return __awaiter(_this8, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return promiseTimeout(exitTimeout, exitHandlerCb(signal)).then(function () {
                  log.debug("".concat(name, " exit (").concat(_signal, ") success"));
                }).catch(function (error) {
                  // most likely timeout
                  log.warn("".concat(name, " exit (").concat(_signal, ") failed with Error:"), error);
                  process.exitCode = 999;
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    });
  });
}

function flatten(arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(arr));
}

function collectPromises(sources, extractor) {
  return Promise.all(sources.map(extractor)).then(flatten);
}

function mapMap(map, fun) {
  return new Map(Array.from(map, function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return [key, fun(val)];
  }));
}

var index =
/*#__PURE__*/
Object.freeze({
  setExitHandler: setExitHandler,
  promiseTimeout: promiseTimeout,
  logger: logger,
  flatten: flatten,
  collectPromises: collectPromises,
  mapMap: mapMap
});
var domain; // This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).

function EventHandlers() {}

EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
} // nodejs oddity
// require('events') === require('events').EventEmitter


EventEmitter.EventEmitter = EventEmitter;
EventEmitter.usingDomains = false;
EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.

EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function () {
  this.domain = null;

  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active && !(this instanceof domain.Domain)) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.


EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
}; // These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.


function emitNone(handler, isFn, self) {
  if (isFn) handler.call(self);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self);
    }
  }
}

function emitOne(handler, isFn, self, arg1) {
  if (isFn) handler.call(self, arg1);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1);
    }
  }
}

function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn) handler.call(self, arg1, arg2);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1, arg2);
    }
  }
}

function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn) handler.call(self, arg1, arg2, arg3);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1, arg2, arg3);
    }
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn) handler.apply(self, args);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].apply(self, args);
    }
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = type === 'error';
  events = this._events;
  if (events) doError = doError && events.error == null;else if (!doError) return false;
  domain = this.domain; // If there is no 'error' event listener then throw.

  if (doError) {
    er = arguments[1];

    if (domain) {
      if (!er) er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }

    return false;
  }

  handler = events[type];
  if (!handler) return false;
  var isFn = typeof handler === 'function';
  len = arguments.length;

  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;

    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;

    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;

    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower

    default:
      args = new Array(len - 1);

      for (i = 1; i < len; i++) {
        args[i - 1] = arguments[i];
      }

      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = target._events;

  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object

      events = target._events;
    }

    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    } // Check for listener leak


    if (!existing.warned) {
      m = $getMaxListeners(target);

      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}

function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function _onceWrap(target, type, listener) {
  var fired = false;

  function g() {
    target.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }

  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
}; // emits a 'removeListener' event iff the listener was removed


EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events) return this;
  list = events[type];
  if (!list) return this;

  if (list === listener || list.listener && list.listener === listener) {
    if (--this._eventsCount === 0) this._events = new EventHandlers();else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list[0] = undefined;

      if (--this._eventsCount === 0) {
        this._events = new EventHandlers();
        return this;
      } else {
        delete events[type];
      }
    } else {
      spliceOne(list, position);
    }

    if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events;
  events = this._events;
  if (!events) return this; // not listening for removeListener, no need to emit

  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    } else if (events[type]) {
      if (--this._eventsCount === 0) this._events = new EventHandlers();else delete events[type];
    }

    return this;
  } // emit removeListener for all listeners on all events


  if (arguments.length === 0) {
    var keys = Object.keys(events);

    for (var i = 0, key; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }

    this.removeAllListeners('removeListener');
    this._events = new EventHandlers();
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    do {
      this.removeListener(type, listeners[listeners.length - 1]);
    } while (listeners[0]);
  }

  return this;
};

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;
  if (!events) ret = [];else {
    evlistener = events[type];
    if (!evlistener) ret = [];else if (typeof evlistener === 'function') ret = [evlistener.listener || evlistener];else ret = unwrapListeners(evlistener);
  }
  return ret;
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;

function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
}; // About 1.5x faster than the two-arg version of Array#splice().


function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);

  while (i--) {
    copy[i] = arr[i];
  }

  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);

  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }

  return ret;
}

var log$1 = logger("EthereumConnection");
var DEFAULTS = {
  ETHEREUM_CONNECTION_TIMEOUT: 10000,
  ETHEREUM_CONNECTION_CLOSE_TIMEOUT: 10000,
  ETHEREUM_ISLISTENING_TIMEOUT: 1000,
  ETHEREUM_CONNECTION_CHECK_INTERVAL: 1000,
  LOG_AS_SUCCESS_AFTER_N_CONFIRMATION: 3,
  INFURA_PROJECT_ID: ""
};
/**
 * Connect to Ethereum network via web3
 *  Maintains connection state, network properties
 *  Reconnects in case of connection dropped. NB: each consumer has to resubscribe atm after reconnection (on "connected" event)
 *  Usage:
 *      const ethereumConnection = new EthereumConnection();
 *      await ethereumConnection.connect().catch( e => {..} )
 * @fires   EthereumConnection#connected
 * @fires   EthereumConnection#disconnected NB: it's only in case of error code 1000, normal end
 * @fires   EthereumConnection#connectionLost
 * @extends EventEmitter
 */

var EthereumConnection =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(EthereumConnection, _EventEmitter);

  function EthereumConnection(runtimeOptions) {
    var _this9;

    _classCallCheck(this, EthereumConnection);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(EthereumConnection).call(this));
    _this9.isStopping = false;
    /**  flag to avoid retrying connection when stop() called intentionally  */

    _this9.isTryingToReconnect = false;
    /** flag to avoid  trying to reconnect if already */

    _this9.wasConnected = false;
    /** internal flag used to supress repeating connection lost logging */

    /**
     * @namespace
     * @prop {object}   web3    web3.js object
     * @prop {object}   provider    shorthand for web3.currentProvider
     * @prop {boolean}  isStopping  indicates if the connection is being shut down (ie. via stop())
     * @prop {number}   networkId
     * @prop {array}    accounts       array of available accounts received from web3.eth.getAccounts()
     * @prop {number}   blockGasLimit    the block gas limit when the connection was estabilished
     * @prop {number}   safeBlockGasLimit  as blockGasLimit read on startup and it can change later so we provide a "safe" estimate which is 90% of the gasLimit
     * @prop {boolean}  isStopping      true when shutting down because stop() has been called (e.g. SIGTERM/SIGSTOP/SIGINT
     * @prop {boolean}  isTryingToReconnect  true while trying to reconnect because of connection loss detected
     */

    _this9.givenProvider = runtimeOptions.givenProvider;
    _this9.options = Object.assign({}, DEFAULTS, runtimeOptions, {
      givenProvider: undefined
    });

    if (_this9.givenProvider && (_this9.options.PROVIDER_URL || _this9.options.PROVIDER_TYPE)) {
      throw new AugmintJsError("EthereumConnection error. Both givenProvider and PROVIDER_TYPE or PROVIDER_URL passed as option. Use either provider or PROVIDER_TYPE + PROVIDER_URL not both  ");
    }

    if (!_this9.givenProvider) {
      if (_this9.options.PROVIDER_TYPE !== "websocket" && _this9.options.PROVIDER_TYPE !== "http") {
        throw new AugmintJsError("EthereumConnection error. Invalid PROVIDER_TYPE: " + _this9.options.PROVIDER_TYPE + " Only websocket or http is supported at the moment.\nYou can also pass custom provider using givenProvider constructor arg");
      }

      if (!_this9.options.PROVIDER_URL) {
        throw new AugmintJsError("EthereumConnection error. No PROVIDER_URL specified while PROVIDER_TYPE is provided.");
      }
    }

    setExitHandler(_this9._exit.bind(_assertThisInitialized(_this9)), "ethereumConnection", _this9.options.ETHEREUM_CONNECTION_CLOSE_TIMEOUT + 1000);
    log$1.info( // IMPORTANT: NEVER expose keys even not in logs!
    "** EthereumConnection loaded with settings:\n            givenProvider: ".concat(_this9.givenProvider ? "set" : "not set", "\n            PROVIDER_TYPE: ").concat(_this9.options.PROVIDER_TYPE, "\n            PROVIDER_URL: ").concat(_this9.options.PROVIDER_URL, "\n            INFURA_PROJECT_ID: ").concat(_this9.options.INFURA_PROJECT_ID ? _this9.options.INFURA_PROJECT_ID.substring(0, 4) + "... rest hidden" : "not provided", "\n            ETHEREUM_CONNECTION_CHECK_INTERVAL: ").concat(_this9.options.ETHEREUM_CONNECTION_CHECK_INTERVAL, "\n            LOG_AS_SUCCESS_AFTER_N_CONFIRMATION: ").concat(_this9.options.LOG_AS_SUCCESS_AFTER_N_CONFIRMATION));
    return _this9;
  }
  /**
   * Get connection state
   *
   * @returns {Promise<boolean>}  result from  web3.eth.net.isListening()
   * @memberof EthereumConnection
   */


  _createClass(EthereumConnection, [{
    key: "isConnected",
    value: function isConnected() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                result = false;

                if (!this.web3) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return promiseTimeout(this.options.ETHEREUM_ISLISTENING_TIMEOUT, this.web3.eth.net.isListening()).catch(function () {
                  // Need timeout b/c listening pending forever when called after a connection.close() TODO: test if needed in newer web3 than beta 33
                  // log.debug("isConnected isListening ERROR (returning false)", e);
                  return false;
                });

              case 4:
                result = _context3.sent;

              case 5:
                return _context3.abrupt("return", result);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     *  next nonce for the account
     * @param  {string}  account Ethereum account with leading 0x
     * @return {Promise}         The result web3.eth.getTransactionCount(account) which is essentially the nonce for the next tx
     */

  }, {
    key: "getAccountNonce",
    value: function getAccountNonce(account) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.web3.eth.getTransactionCount(account);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this10 = this;

        var connectedEventPromise;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.isStopping = false;

                if (!(!this.givenProvider && this.options.PROVIDER_TYPE && this.options.PROVIDER_URL)) {
                  _context7.next = 12;
                  break;
                }

                _context7.t0 = this.options.PROVIDER_TYPE;
                _context7.next = _context7.t0 === "http" ? 5 : _context7.t0 === "websocket" ? 7 : 9;
                break;

              case 5:
                this.provider = new Web3.providers.HttpProvider(this.options.PROVIDER_URL + this.options.INFURA_PROJECT_ID);
                return _context7.abrupt("break", 10);

              case 7:
                this.provider = new Web3.providers.WebsocketProvider(this.options.PROVIDER_URL + this.options.INFURA_PROJECT_ID);
                return _context7.abrupt("break", 10);

              case 9:
                throw new AugmintJsError(this.options.PROVIDER_TYPE + " is not supported yet");

              case 10:
                _context7.next = 13;
                break;

              case 12:
                this.provider = this.givenProvider;

              case 13:
                if (typeof this.provider.on !== "function") {
                  this.isProviderWithEvents = false;
                } else {
                  this.isProviderWithEvents = true;
                  this.provider.on("error", this.onProviderError.bind(this));
                  this.provider.on("end", this.onProviderEnd.bind(this));
                }

                if (this.web3) {
                  // it's  a reconnect
                  this.web3.setProvider(this.provider);
                } else {
                  this.web3 = new Web3(this.provider);
                }

                if (this.isProviderWithEvents) {
                  _context7.next = 19;
                  break;
                }

                _context7.next = 18;
                return this.initAfterProviderConnect();

              case 18:
                return _context7.abrupt("return");

              case 19:
                connectedEventPromise = new Promise(function (resolve, reject) {
                  return __awaiter(_this10, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee6() {
                    var _this11 = this;

                    var tempOnConnected, tempOnproviderError, tempOnConnectionLost;
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return this.isConnected();

                          case 2:
                            if (!_context6.sent) {
                              _context6.next = 8;
                              break;
                            }

                            _context6.next = 5;
                            return this.initAfterProviderConnect();

                          case 5:
                            resolve();
                            _context6.next = 14;
                            break;

                          case 8:
                            tempOnConnected = function tempOnConnected() {
                              return __awaiter(_this11, void 0, void 0,
                              /*#__PURE__*/
                              _regeneratorRuntime.mark(function _callee5() {
                                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                  while (1) {
                                    switch (_context5.prev = _context5.next) {
                                      case 0:
                                        this.removeListener("providerError", tempOnproviderError);
                                        this.removeListener("connectionLost", tempOnConnectionLost);
                                        _context5.next = 4;
                                        return this.initAfterProviderConnect();

                                      case 4:
                                        resolve(); // we wait for our custom setup to finish before we resolve connect()

                                      case 5:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }
                                }, _callee5, this);
                              }));
                            };

                            tempOnproviderError = function tempOnproviderError() {
                              _this11.removeListener("connected", tempOnConnected);

                              _this11.removeListener("connectionLost", tempOnConnectionLost);

                              reject(new AugmintJsError("EthereumConnection connect failed. Provider error received instead of connect"));
                            };

                            tempOnConnectionLost = function tempOnConnectionLost(e) {
                              _this11.removeListener("connected", tempOnConnected);

                              _this11.removeListener("providerError", tempOnproviderError);

                              reject(new AugmintJsError("EthereumConnection connect failed. connectionLost received instead of connect. Code: ".concat(e.code, " Reason: ").concat(e.reason)));
                            };

                            this.once("connectionLost", tempOnConnectionLost);
                            this.once("connected", tempOnConnected);
                            this.once("providerError", tempOnproviderError); // this would be better: this.provider.once("end", e => { .. but web3js has a bug subscrbuing the same event multiple times.

                          case 14:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));
                });
                _context7.next = 22;
                return promiseTimeout(this.options.ETHEREUM_CONNECTION_TIMEOUT, connectedEventPromise).catch(function (error) {
                  throw new AugmintJsError("EthereumConnection connect error. " + error);
                });

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop()
    /*signal*/
    {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this12 = this;

        var disconnectedEventPromise;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.isStopping = true;
                clearTimeout(this.connectionCheckTimer);

                if (!this.isProviderWithEvents) {
                  _context8.next = 14;
                  break;
                }

                _context8.t0 = this.web3;

                if (!_context8.t0) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 7;
                return this.isConnected();

              case 7:
                _context8.t0 = _context8.sent;

              case 8:
                if (!_context8.t0) {
                  _context8.next = 14;
                  break;
                }

                disconnectedEventPromise = new Promise(function (resolve) {
                  _this12.once("disconnected", function () {
                    resolve();
                  });
                });
                _context8.next = 12;
                return this.web3.currentProvider.connection.close();

              case 12:
                _context8.next = 14;
                return promiseTimeout(this.options.ETHEREUM_CONNECTION_CLOSE_TIMEOUT, disconnectedEventPromise);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "initAfterProviderConnect",
    value: function initAfterProviderConnect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var lastBlock, _ref4, _ref5;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                clearTimeout(this.connectionCheckTimer);
                _context9.next = 3;
                return Promise.all([this.web3.eth.net.getId().then(function (res) {
                  return parseInt(res, 10);
                }), this.web3.eth.getBlock("latest"), this.web3.eth.getAccounts()]);

              case 3:
                _ref4 = _context9.sent;
                _ref5 = _slicedToArray(_ref4, 3);
                this.networkId = _ref5[0];
                lastBlock = _ref5[1];
                this.accounts = _ref5[2];
                this.blockGasLimit = lastBlock.gasLimit;
                this.safeBlockGasLimit = Math.round(this.blockGasLimit * 0.9);

                if (this.isTryingToReconnect) {
                  this.isTryingToReconnect = false;
                  log$1.warn(" EthereumConnection - provider connection recovered");
                } else {
                  log$1.debug(" EthereumConnection - provider connected");
                }

                this.wasConnected = true;

                if (this.options.ETHEREUM_CONNECTION_CHECK_INTERVAL > 0) {
                  this.connectionCheckTimer = setInterval(this._checkConnection.bind(this), this.options.ETHEREUM_CONNECTION_CHECK_INTERVAL);
                }

                this.emit("connected", this);

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "onProviderEnd",
    value: function onProviderEnd(e) {
      if (e.code === 1000) {
        // Normal connection closure (currentProvider.close() was called from stop())
        log$1.debug(" EthereumConnection - Websocket ended with normal end code:", e.code, e.reason);
        this.emit("disconnected", e, this);
      } else {
        if (!this.isTryingToReconnect && !this.isStopping) {
          // Unexpected connection loss - _checkConnection() will try to reconnect in every RECONNECT_INTERVAL
          log$1.warn(" EthereumConnection - Websocket connection ended with code:", e.code, e.reason);
          this.emit("connectionLost", e, this);
        }
      }
    }
  }, {
    key: "onProviderError",
    value: function onProviderError(event) {
      // NB: This is triggered with every isConnected() call too when not connected
      //  Supressing repeating logs while reconnecting - common due to infura dropping web3 connection ca. in every 1-2 hours)
      //       TODO: check if we should implement web3 keepalive pings or if newever versions on web3js are supporting it
      if (!this.isTryingToReconnect && !this.isStopping && this.wasConnected) {
        this.emit("providerError", event, this);
        log$1.warn(" EthereumConnection - provider error. Trying to reconnect. Logging provider errors are supressed until sucessfull reconnect.");
      }
    }
  }, {
    key: "_exit",
    value: function _exit(signal) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.stop();

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "_checkConnection",
    value: function _checkConnection() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.t0 = !this.isStopping;

                if (!_context11.t0) {
                  _context11.next = 5;
                  break;
                }

                _context11.next = 4;
                return this.isConnected();

              case 4:
                _context11.t0 = !_context11.sent;

              case 5:
                if (!_context11.t0) {
                  _context11.next = 8;
                  break;
                }

                if (this.wasConnected) {
                  // emit connectionLost (and log) only first reconnect attempt
                  log$1.debug(" EthereumConnection _checkConnection() - ethereumConnection.isConnected() returned false. trying to reconnect");
                  this.emit("connectionLost", {
                    reason: "checkConnection detected connectionloss"
                  }, this); // triggering this so modules can handle event

                  this.wasConnected = false;
                }

                this._tryToReconnect();

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "_tryToReconnect",
    value: function _tryToReconnect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(!this.isStopping && !this.isTryingToReconnect)) {
                  _context12.next = 6;
                  break;
                }

                // we won't try to reconnect if previous is still running (this.isTryingToReconnect)
                //    i.e the prev connect() will errror or worst case timeout in ETHEREUM_CONNECTION_TIMEOUT ms and _checkConnection is called in every x ms
                if (this.wasConnected) {
                  log$1.warn("  EthereumConnection connnection lost to web3 provider. Keep trying to reconnect. Logging of further warnings supressed until connection recovers");
                }

                this.isTryingToReconnect = true;
                _context12.next = 5;
                return this.connect().catch(function (e) {
                  // we ignore error and wait for next attempt to be triggered in ETHEREUM_CONNECTION_CHECK_INTERVAL ms
                  log$1.debug(" EthereumConnection reconnection attempt error:", e);
                });

              case 5:
                this.isTryingToReconnect = false;

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }]);

  return EthereumConnection;
}(EventEmitter);

var NEW_LOAN_GAS = 240000; // As of now it's on ganache: 167,196-167390 - 182,000???

var NEW_FIRST_LOAN_GAS = 240000; // 227390

var REPAY_GAS = 150000; // AugmintToken.transferAndNotify, as of now on testRpc: first: 105,354, tehn : 120305 ?

var COLLECT_BASE_GAS = 90000; // as of now on testRpc: 1 loan = first: 73,333, consecutive:  64,683

var COLLECT_ONE_GAS = 40000; // as of now: ca. 10000

var TRANSFER_AUGMINT_TOKEN_GAS = 100000; // on testrpc: first: 75189 - 75405, rinkeby first: 76629
// consecutive : no narr: 45405 - 60405 (higher when sent to account which never received)
// w narrative: 46733 - 56693

var PLACE_ORDER_GAS = 200000;
var MATCH_ORDERS_GAS = 150000; // a single matchOrders
// base cost for matchMultipleOrders
// actual on ganache: 80667 but requires higher b/c Exchange contract's matchMultipleOrders stops matching if gasLeft < 100k

var MATCH_MULTIPLE_FIRST_MATCH_GAS = 200000; // additional cost for each match for matchMultipleOrder.
// actual on ganache: 2nd: +57760. then between 45652-47767, sometimes 5783?

var MATCH_MULTIPLE_ADDITIONAL_MATCH_GAS = 50000; // actuals on ganache: sell cancel: 31891-43725 / buy cancel: 24264-28470
//    last sell order cancel reverts in ganache with 60000 gas limit despite it runs w/ 31891 gas... likely a ganache bug

var CANCEL_ORDER_GAS = 70000;
var LEGACY_BALANCE_CONVERT_GAS = 200000;
var NEW_LOCK_GAS = 200000; // actual on ganache: 176761

var NEW_FIRST_LOCK_GAS = 240000; // actual on ganache: 206761

var RELEASE_LOCK_GAS = 100000; // actual on ganache: 62515

var SET_RATE_GAS_LIMIT = 80000;
var gas =
/*#__PURE__*/
Object.freeze({
  NEW_LOAN_GAS: NEW_LOAN_GAS,
  NEW_FIRST_LOAN_GAS: NEW_FIRST_LOAN_GAS,
  REPAY_GAS: REPAY_GAS,
  COLLECT_BASE_GAS: COLLECT_BASE_GAS,
  COLLECT_ONE_GAS: COLLECT_ONE_GAS,
  TRANSFER_AUGMINT_TOKEN_GAS: TRANSFER_AUGMINT_TOKEN_GAS,
  PLACE_ORDER_GAS: PLACE_ORDER_GAS,
  MATCH_ORDERS_GAS: MATCH_ORDERS_GAS,
  MATCH_MULTIPLE_FIRST_MATCH_GAS: MATCH_MULTIPLE_FIRST_MATCH_GAS,
  MATCH_MULTIPLE_ADDITIONAL_MATCH_GAS: MATCH_MULTIPLE_ADDITIONAL_MATCH_GAS,
  CANCEL_ORDER_GAS: CANCEL_ORDER_GAS,
  LEGACY_BALANCE_CONVERT_GAS: LEGACY_BALANCE_CONVERT_GAS,
  NEW_LOCK_GAS: NEW_LOCK_GAS,
  NEW_FIRST_LOCK_GAS: NEW_FIRST_LOCK_GAS,
  RELEASE_LOCK_GAS: RELEASE_LOCK_GAS,
  SET_RATE_GAS_LIMIT: SET_RATE_GAS_LIMIT
});
/**
 * Transaction class to manage Ethereum transactions thourgh it's lifecycle.
 *
 * Recommended use:
 *  @example
 *     const ethereumConnection = new EthereumConnection(config);
 *     const rates = new Rates();
 *     await rates.connect()
 *     rates.setRate("USD", 121.12)
 *       .[sign(privatekey, {from: acc, to:rates.address})]  // optionally you can sign
 *       .send([{from: acc}]) // from only needed if it's not signed
 *       .onceTxHash( txHash => {.. })
 *       .onceReceipt( receipt => { ...})
 *       .onConfirmation( (confirmationNumber, receipt) => {...}
 *       .onceReceiptConfirmed(5, receipt => {...})
 *       .onceTxRevert( (error, receipt) => { ....})
 *
 *  // To catch errors you need to use txHash / confirmation / receipt getters:
 *  try {
 *    const txHash = await tx.getTxHash()
 *    const txReceipt = await tx.getReceipt() // receipt as soon as got it (even with 0 confirmation)
 *    const confirmedReceipt = await tx.getConfirmedReceipt(12) // receipt after x confirmation.
 *    // receipt you need to check for receipt.status if tx was Reverted or not.
 *    if (confirmedReceipt.status) {
 *      // all good
 *    } else {
 *      // this tx was reverted
 *    }
 *  } catch (error) {
 *     // These Promises are rejecting with sending errors or when txhash / receipt times out.
 * }
 *
 * // Deprecated and discouraged but kept for backward compatibility  with web3js style events:
 *  tx.on[ce]("transactionHash" | "receipt" | "confirmation" | "error")
 * // This way it can be easily plugged into dapps which are handling web3js tx objects:
 * //   augmint-js Transaction object can be a drop in as an almost direct replacement of webjs transactioObject
 *
 * // To construct a transaction:
 *  const web3TxObject = rates.instance.methods.setRate(CCY, 100)
 *  const augmintRatesTx = new Transaction(ethereumConnection, web3TxObject, {gasLimit: 200000}); // you can set the gaslimit here or later at send() too
 *  augmintRatesTx.send(...).onTxHash(...)  // or sign().send() etc.
 *
 *
 * @export
 * @fires   transactionHash
 * @fires   receipt     fired as soon as a receipt received
 * @fires   confirmation    fired for each confirmation
 * @fires   error       @deprecated - fired in case of any error. kept for backward compatibility
 * @fires   txRevert   fired when tx was mined but with REVERT opcode. error also fired in this case for backward compatibility
 * @class Transaction
 * @extends {EventEmitter}
 */

var Transaction =
/*#__PURE__*/
function (_EventEmitter2) {
  _inherits(Transaction, _EventEmitter2);

  /**
   * Creates an instance of Transaction.
   *
   * @param {EthereumConnection} ethereumConnection
   * @param {TransactionObject<any>} tx   the web3.js transaction object
   * @param {ISendOptions} [sendOptions]  optionally specify any of the send options here or later at sign or send
   * @memberof Transaction
   */
  function Transaction(ethereumConnection, tx, sendOptions) {
    var _this13;

    _classCallCheck(this, Transaction);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(Transaction).call(this));
    _this13.isTxSent = false;
    /** indicate if .send was already called */

    if (!ethereumConnection || !tx) {
      throw new TransactionError("Both ethereumConnection and tx must be provided for Transaction constructor");
    }

    _this13.tx = tx;
    _this13.sendOptions = Object.assign({}, sendOptions);
    _this13.ethereumConnection = ethereumConnection;
    return _this13;
  }
  /**
   * Sign the transaction with the provided private key
   *      and with the from, to, gas in ISendOptions.
   *      ISendOptions can be set in [Transaction] constructor too.
   *      make sure you set at least gasLimit and from.
   * @param {string} privateKey   Private key with leading 0x
   * @param {ISendOptions} sendOptions
   * @returns {Transaction}   the [Transaction] object for chaining. Call [send] or [getSignedTranscation] on it
   * @memberof Transaction
   */


  _createClass(Transaction, [{
    key: "sign",
    value: function sign(privateKey, sendOptions) {
      var _this14 = this;

      if (this.isTxSent) {
        throw new TransactionError("tx was already sent");
      }

      this.sendOptions = Object.assign({}, this.sendOptions, sendOptions);

      if (!this.sendOptions.from) {
        throw new TransactionError("from account is not set for sign");
      }

      this.txToSign = Object.assign({}, this.sendOptions, {
        data: this.tx.encodeABI()
      });
      this.signedTxPromise = new Promise(function (resolve) {
        return __awaiter(_this14, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee13() {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return this.ethereumConnection.web3.eth.accounts.signTransaction(this.txToSign, privateKey);

                case 2:
                  this.signedTx = _context13.sent;
                  resolve(this.signedTx);

                case 4:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));
      });
      return this;
    }
  }, {
    key: "getSignedTx",
    value: function getSignedTx() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (this.signedTxPromise) {
                  _context14.next = 2;
                  break;
                }

                throw new TransactionError("call .sign() first to get a signed transaction");

              case 2:
                return _context14.abrupt("return", this.signedTxPromise);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "send",
    value: function send(sendOptions) {
      var _this15 = this;

      if (this.isTxSent) {
        throw new TransactionError("tx was already sent");
      }

      this.isTxSent = true;
      this.sendOptions = Object.assign({}, this.sendOptions, sendOptions);

      if (this.signedTxPromise) {
        this.getSignedTx().then(function (signedTx) {
          if (_this15.sendOptions.from && _this15.txToSign && _this15.txToSign.from && _this15.sendOptions.from.toLowerCase() !== _this15.txToSign.from.toLowerCase()) {
            throw new TransactionError("tx sign(sendOptions) and send( sendOptions)  mismatch: from is differnt. Either don't provide from in sendOptions for send() or provide the same from address as for sign()");
          }

          _this15.sentTx = _this15.ethereumConnection.web3.eth.sendSignedTransaction(signedTx.rawTransaction);

          _this15.addTxListeners(_this15.sentTx);
        });
      } else {
        if (!this.sendOptions.from) {
          throw new TransactionError("from account is not set for send");
        }

        try {
          this.sentTx = this.tx.send(Object.assign({}, this.sendOptions)); // webjs writes into passed params (beta36) (added .data to .sendOptions and Metamask hang for long before confirmation apperaed)
        } catch (error) {
          this.sendError = new TransactionSendError(error);
          throw this.sendError;
        }

        this.addTxListeners(this.sentTx);
      }

      return this;
    }
  }, {
    key: "getTxHash",
    value: function getTxHash() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var _this16 = this;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.isTxSent) {
                  _context15.next = 2;
                  break;
                }

                throw new TransactionError("tx was not sent yet");

              case 2:
                if (!this.txHashPromise) {
                  this.txHashPromise = new Promise(function (resolve, reject) {
                    if (_this16.txHash) {
                      resolve(_this16.txHash);
                    }

                    if (_this16.sendError) {
                      reject(_this16.sendError); // tx already rejected and still no txHash
                    } // tx not resolved yet so wait for our own transactionHash event


                    _this16.once("transactionHash", function (hash) {
                      _this16.txHash = hash;
                      resolve(hash);
                    });

                    _this16.once("error", function (error) {
                      if (_this16.txHash) {
                        // it's a tx revert. we still return the hash.
                        resolve(_this16.txHash);
                      } else {
                        reject(error);
                      }
                    });
                  });
                }

                return _context15.abrupt("return", this.txHashPromise);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "getTxReceipt",
    value: function getTxReceipt() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        var _this17 = this;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (this.isTxSent) {
                  _context16.next = 2;
                  break;
                }

                throw new TransactionError("tx was not sent yet");

              case 2:
                if (!this.txReceiptPromise) {
                  this.txReceiptPromise = new Promise(function (resolve, reject) {
                    if (_this17.txReceipt) {
                      resolve(_this17.txReceipt);
                    }

                    if (_this17.sendError) {
                      reject(_this17.sendError); // if tx already rejected and still no receipt
                    } // tx not resolved yet so wait for our own transactionHash event


                    _this17.once("receipt", function (receipt) {
                      resolve(receipt);
                    });

                    _this17.once("error", function (error) {
                      if (_this17.txReceipt) {
                        resolve(_this17.txReceipt);
                      } else {
                        reject(error);
                      }
                    });
                  });
                }

                return _context16.abrupt("return", this.txReceiptPromise);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "getConfirmedReceipt",
    value: function getConfirmedReceipt() {
      var confirmationNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var _this18 = this;

        var txConfirmationPromise;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.isTxSent) {
                  _context17.next = 2;
                  break;
                }

                throw new TransactionError("tx was not sent yet");

              case 2:
                if (!(this.confirmationCount && this.confirmationCount >= confirmationNumber)) {
                  _context17.next = 4;
                  break;
                }

                return _context17.abrupt("return", this.txReceipt);

              case 4:
                txConfirmationPromise = new Promise(function (resolve, reject) {
                  if (_this18.sendError && !_this18.txReceipt) {
                    reject(_this18.sendError); // if tx already rejected and still no receipt
                  }

                  _this18.on("confirmation", function (confNum, receipt) {
                    if (confNum >= confirmationNumber) {
                      resolve(_this18.txReceipt);
                    }
                  }); // TODO: reject after x blocks if no confirmation received

                });
                return _context17.abrupt("return", txConfirmationPromise);

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "onceTxRevert",
    value: function onceTxRevert(callback) {
      this.once("txRevert", callback);
      return this;
    }
  }, {
    key: "onceTxHash",
    value: function onceTxHash(callback) {
      this.once("transactionHash", callback);
      return this;
    }
  }, {
    key: "onceReceipt",
    value: function onceReceipt(callback) {
      this.once("receipt", callback);
      return this;
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(callback) {
      this.on("confirmation", callback);
      return this;
    }
  }, {
    key: "onceConfirmedReceipt",
    value: function onceConfirmedReceipt(confirmationNumber, callback) {
      var _this19 = this;

      this.once("transactionHash", function () {
        return __awaiter(_this19, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee18() {
          var receipt;
          return _regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.next = 2;
                  return this.getConfirmedReceipt(confirmationNumber);

                case 2:
                  receipt = _context18.sent;
                  callback(receipt);

                case 4:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18, this);
        }));
      });
      return this;
    }
  }, {
    key: "addTxListeners",
    value: function addTxListeners(tx) {
      var _this20 = this;

      tx.once("transactionHash", function (hash) {
        _this20.txHash = hash;

        _this20.emit("transactionHash", hash);
      }).once("receipt", function (receipt) {
        _this20.setReceipt(receipt);
      }).on("error", function (error, receipt) {
        return __awaiter(_this20, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee19() {
          var _this21 = this;

          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  this.sendError = new TransactionSendError(error);

                  if (!this.txHash) {
                    _context19.next = 10;
                    break;
                  }

                  if (this.txReceipt) {
                    _context19.next = 8;
                    break;
                  }

                  _context19.t0 = this;
                  _context19.next = 6;
                  return this.ethereumConnection.web3.eth.getTransactionReceipt(this.txHash);

                case 6:
                  _context19.t1 = _context19.sent;

                  _context19.t0.setReceipt.call(_context19.t0, _context19.t1);

                case 8:
                  // workaround that web3js beta36 is not emmitting confirmation events when tx fails on tx REVERT
                  this.sentTx.on("confirmation", function (confirmationNumber, receiptFromConf) {
                    _this21.confirmationCount = confirmationNumber;

                    _this21.emit("confirmation", confirmationNumber);
                  });
                  this.emit("txRevert", this.sendError, this.txReceipt);

                case 10:
                  this.emit("error", this.sendError, this.txReceipt);

                case 11:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19, this);
        }));
      }).on("confirmation", function (confirmationNumber, receipt) {
        _this20.confirmationCount = confirmationNumber;

        _this20.emit("confirmation", confirmationNumber);
      });
    }
  }, {
    key: "setReceipt",
    value: function setReceipt(receipt) {
      if (!this.txReceipt && receipt) {
        this.txReceipt = receipt;
        this.emit("receipt", this.txReceipt);
      }
    }
  }]);

  return Transaction;
}(EventEmitter);

var OrderBook =
/*#__PURE__*/
function () {
  function OrderBook(buyOrders, sellOrders) {
    _classCallCheck(this, OrderBook);

    this.buyOrders = buyOrders;
    this.sellOrders = sellOrders;
    buyOrders.sort(OrderBook.compareBuyOrders);
    sellOrders.sort(OrderBook.compareSellOrders);
  }

  _createClass(OrderBook, [{
    key: "hasMatchingOrders",
    value: function hasMatchingOrders() {
      if (this.buyOrders.length === 0 || this.sellOrders.length === 0) {
        return false;
      }

      return this.sellOrders[0].price.lte(this.buyOrders[0].price);
    }
    /**
     * calculate matching pairs from ordered ordebook for sending in Exchange.matchMultipleOrders ethereum tx
     * @param  {Tokens} ethFiatRate current ETHFiat rate to use for calculation
     * @param  {number} gasLimit       return as many matches as it fits to gasLimit based on gas cost estimate.
     * @return {object}                pairs of matching order id , ordered by execution sequence { buyIds: [], sellIds: [], gasEstimate }
     */

  }, {
    key: "getMatchingOrders",
    value: function getMatchingOrders(ethFiatRate, gasLimit) {
      var sellIds = [];
      var buyIds = [];

      if (!this.hasMatchingOrders()) {
        return {
          buyIds: buyIds,
          sellIds: sellIds,
          gasEstimate: 0
        };
      }

      var lowestSellPrice = this.sellOrders[0].price;
      var highestBuyPrice = this.buyOrders[0].price;

      var clone = function clone(o) {
        return Object.assign({}, o);
      };

      var buys = this.buyOrders.filter(function (o) {
        return o.price.gte(lowestSellPrice);
      }).map(clone);
      var sells = this.sellOrders.filter(function (o) {
        return o.price.lte(highestBuyPrice);
      }).map(clone);
      var buyIdx = 0;
      var sellIdx = 0;
      var gasEstimate = 0;
      var nextGasEstimate = MATCH_MULTIPLE_FIRST_MATCH_GAS;

      while (buyIdx < buys.length && sellIdx < sells.length && nextGasEstimate <= gasLimit) {
        var sell = sells[sellIdx];
        var buy = buys[buyIdx];
        sellIds.push(sell.id);
        buyIds.push(buy.id); // matching logic follows smart contract _fillOrder implementation
        // see https://github.com/Augmint/augmint-contracts/blob/staging/contracts/Exchange.sol

        var price = buy.id > sell.id ? sell.price : buy.price;
        var sellWei = sell.amount.toWeiAt(ethFiatRate, price);
        var tradedWei = void 0;
        var tradedTokens = void 0;

        if (sellWei.lte(buy.amount)) {
          tradedWei = sellWei;
          tradedTokens = sell.amount;
        } else {
          tradedWei = buy.amount;
          tradedTokens = tradedWei.toTokensAt(ethFiatRate, price);
        }

        buy.amount = buy.amount.sub(tradedWei);

        if (buy.amount.isZero()) {
          buyIdx++;
        }

        sell.amount = sell.amount.sub(tradedTokens);

        if (sell.amount.isZero()) {
          sellIdx++;
        }

        gasEstimate = nextGasEstimate;
        nextGasEstimate += MATCH_MULTIPLE_ADDITIONAL_MATCH_GAS;
      }

      return {
        buyIds: buyIds,
        sellIds: sellIds,
        gasEstimate: gasEstimate
      };
    }
    /**
     * calculate price for n amount of token to buy
     * @return {object} simple buy data { tokens, ethers, limitPrice, averagePrice }
     * @param tokenAmount - amount of token to buy
     * @param ethFiatRate - current rate
     */

  }, {
    key: "estimateMarketBuy",
    value: function estimateMarketBuy(tokenAmount, ethFiatRate) {
      return OrderBook.estimateMarketOrder(this.sellOrders, tokenAmount, ethFiatRate, function (order) {
        return order.amount;
      });
    }
    /**
     * calculate price for n amount of token to sell
     * @return {object} simple buy data { tokens, ethers, limitPrice, averagePrice }
     * @param tokenAmount - amount of token to sell
     * @param ethFiatRate - current rate
     */

  }, {
    key: "estimateMarketSell",
    value: function estimateMarketSell(tokenAmount, ethFiatRate) {
      return OrderBook.estimateMarketOrder(this.buyOrders, tokenAmount, ethFiatRate, function (order) {
        return order.amount.toTokensAt(ethFiatRate, order.price);
      });
    }
  }], [{
    key: "compareBuyOrders",
    value: function compareBuyOrders(o1, o2) {
      var cmp = o2.price.cmp(o1.price);
      return cmp !== 0 ? cmp : o1.id - o2.id;
    }
  }, {
    key: "compareSellOrders",
    value: function compareSellOrders(o1, o2) {
      var cmp = o1.price.cmp(o2.price);
      return cmp !== 0 ? cmp : o1.id - o2.id;
    }
  }, {
    key: "estimateMarketOrder",
    value: function estimateMarketOrder(orders, tokens, rate, toTokens) {
      var ret = {
        filledTokens: Tokens.of(0),
        filledEthers: Wei.of(0)
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = orders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var order = _step.value;
          var remaining = tokens.sub(ret.filledTokens);

          if (remaining.isZero()) {
            break;
          }

          var fillTokens = Tokens.min(toTokens(order), remaining);
          var fillEthers = fillTokens.toWeiAt(rate, order.price);
          ret.filledTokens = ret.filledTokens.add(fillTokens);
          ret.filledEthers = ret.filledEthers.add(fillEthers);
          ret.limitPrice = order.price;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (ret.limitPrice) {
        ret.averagePrice = rate.divToRatio(ret.filledTokens.toRate(ret.filledEthers));
      }

      return ret;
    }
  }]);

  return OrderBook;
}();
/**
 * Augmint Exchange contract class
 * @class Exchange
 * @extends Contract
 */
// tslint:disable-next-line:max-classes-per-file


var Exchange =
/*#__PURE__*/
function (_AbstractContract2) {
  _inherits(Exchange, _AbstractContract2);

  function Exchange(deployedContractInstance, options) {
    var _this22;

    _classCallCheck(this, Exchange);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(Exchange).call(this, deployedContractInstance));
    _this22.instance = deployedContractInstance;
    _this22.ethereumConnection = options.ethereumConnection;
    _this22.web3 = _this22.ethereumConnection.web3;
    _this22.safeBlockGasLimit = _this22.ethereumConnection.safeBlockGasLimit;
    _this22.rates = options.rates;
    _this22.token = options.token;
    return _this22;
  }

  _createClass(Exchange, [{
    key: "getOrderBook",

    /**
     * Fetches, parses and orders the current, full orderBook from Exchange
     *
     * @returns {Promise<OrderBook>}   the current, ordered orderBook
     * @memberof Exchange
     */
    value: function getOrderBook() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        var _ref6, _ref7, buyOrders, sellOrders;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return Promise.all([this.getOrders(true), this.getOrders(false)]);

              case 2:
                _ref6 = _context20.sent;
                _ref7 = _slicedToArray(_ref6, 2);
                buyOrders = _ref7[0];
                sellOrders = _ref7[1];
                return _context20.abrupt("return", new OrderBook(buyOrders, sellOrders));

              case 7:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
    /**
     * Fetches current OrderBook and returns as many matching orderIds (at current ETHFiat rate) as fits into the provided gas limit.
     *  if no gasLimit provided then ethereumConnection.safeBlockGasLimit is used
     * The returned matchingOrders can be passed to signAndSendMatchMultiple or matchMultiple functions
     * @param  {number}  [gasLimit=EthereumConnection.safeBlockGasLimit]   return as many matches as it fits to gasLimit based on gas cost estimate.
     * @return {Promise}            pairs of matching order id , ordered by execution sequence { buyIds: [], sellIds: [], gasEstimate }
     */

  }, {
    key: "getMatchingOrders",
    value: function getMatchingOrders() {
      var gasLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.safeBlockGasLimit;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        var tokenPeggedSymbol, _ref8, _ref9, orderBook, ethFiatRate;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.tokenPeggedSymbol;

              case 2:
                tokenPeggedSymbol = _context21.sent;
                _context21.next = 5;
                return Promise.all([this.getOrderBook(), this.rates.getEthFiatRate(tokenPeggedSymbol)]);

              case 5:
                _ref8 = _context21.sent;
                _ref9 = _slicedToArray(_ref8, 2);
                orderBook = _ref9[0];
                ethFiatRate = _ref9[1];
                return _context21.abrupt("return", orderBook.getMatchingOrders(ethFiatRate, gasLimit));

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "placeSellTokenOrder",
    value: function placeSellTokenOrder(price, amount) {
      var web3Tx = this.token.instance.methods.transferAndNotify(this.address, amount.toString(), price.toString());
      var transaction = new Transaction(this.ethereumConnection, web3Tx, {
        gasLimit: PLACE_ORDER_GAS,
        to: this.address
      });
      return transaction;
    }
  }, {
    key: "placeBuyTokenOrder",
    value: function placeBuyTokenOrder(price, amount) {
      var web3Tx = this.instance.methods.placeBuyTokenOrder(price.toString());
      var transaction = new Transaction(this.ethereumConnection, web3Tx, {
        gasLimit: PLACE_ORDER_GAS,
        to: this.address,
        value: amount.amount
      });
      return transaction;
    }
    /**
     *  Returns a [Transaction] object with which can be signed and sent or sent to the ethereum network
     *
     * @param {IMatchingOrders} matchingOrders  use [getMatchingOrders] method to get it
     * @returns {Transaction}
     * @memberof Exchange
     */

  }, {
    key: "matchMultipleOrders",
    value: function matchMultipleOrders(matchingOrders) {
      if (matchingOrders.sellIds.length === 0 || matchingOrders.sellIds.length !== matchingOrders.buyIds.length) {
        throw new Error("invalid buyIds/sellIds recevied - no ids or the the params are not equal.");
      }

      var web3Tx = this.instance.methods.matchMultipleOrders(matchingOrders.buyIds, matchingOrders.sellIds);
      var transaction = new Transaction(this.ethereumConnection, web3Tx, {
        gasLimit: matchingOrders.gasEstimate,
        // to: needs to be set if going to be signed.
        // (getting unhandled rejection errors if not set even tx is successful on ganache. beta36 )
        to: this.address
      });
      return transaction;
    }
  }, {
    key: "getOrders",
    value: function getOrders(buy) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        var chunkSize, orders, i, fetched;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                chunkSize = this.isLegacyExchangeContract ? LEGACY_CONTRACTS_CHUNK_SIZE : CHUNK_SIZE;
                orders = [];
                i = 0;

              case 3:
                _context22.next = 5;
                return this.getOrdersChunk(buy, i * chunkSize, chunkSize);

              case 5:
                fetched = _context22.sent;
                orders.push.apply(orders, _toConsumableArray(fetched));
                i += 1;

              case 8:
                if (fetched.length === chunkSize) {
                  _context22.next = 3;
                  break;
                }

              case 9:
                return _context22.abrupt("return", orders);

              case 10:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "getOrdersChunk",
    value: function getOrdersChunk(buy, offset, chunkSize) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var blockGasLimit, result;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                blockGasLimit = this.safeBlockGasLimit;

                if (!buy) {
                  _context23.next = 14;
                  break;
                }

                if (!this.isLegacyExchangeContract // @ts-ignore  TODO: remove ts-ignore and handle properly when legacy contract support added
                ) {
                  _context23.next = 8;
                  break;
                }

                _context23.next = 5;
                return this.instance.methods.getActiveBuyOrders(offset).call({
                  gas: blockGasLimit
                });

              case 5:
                _context23.t0 = _context23.sent;
                _context23.next = 11;
                break;

              case 8:
                _context23.next = 10;
                return this.instance.methods.getActiveBuyOrders(offset, chunkSize).call({
                  gas: blockGasLimit
                });

              case 10:
                _context23.t0 = _context23.sent;

              case 11:
                result = _context23.t0;
                _context23.next = 24;
                break;

              case 14:
                if (!this.isLegacyExchangeContract // @ts-ignore  TODO: remove ts - ignore and handle properly when legacy contract support added
                ) {
                  _context23.next = 20;
                  break;
                }

                _context23.next = 17;
                return this.instance.methods.getActiveSellOrders(offset).call({
                  gas: blockGasLimit
                });

              case 17:
                _context23.t1 = _context23.sent;
                _context23.next = 23;
                break;

              case 20:
                _context23.next = 22;
                return this.instance.methods.getActiveSellOrders(offset, chunkSize).call({
                  gas: blockGasLimit
                });

              case 22:
                _context23.t1 = _context23.sent;

              case 23:
                result = _context23.t1;

              case 24:
                return _context23.abrupt("return", result.reduce(function (res, order) {
                  var amount = new BN(order[3]);

                  if (!amount.isZero()) {
                    res.push({
                      id: parseInt(order[0], 10),
                      maker: "0x".concat(new BN(order[1]).toString(16).padStart(40, "0")),
                      price: Ratio.parse(order[2]),
                      amount: buy ? new Wei(amount) : new Tokens(amount)
                    });
                  }

                  return res;
                }, []));

              case 25:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "isLegacyExchangeContract",
    get: function get() {
      // @ts-ignore  TODO: remove ts-ignore and handle properly when legacy contract support added
      return typeof this.instance.methods.CHUNK_SIZE === "function";
    }
  }], [{
    key: "OrderBook",
    get: function get() {
      return OrderBook;
    }
  }]);

  return Exchange;
}(AbstractContract);

var collateralStatusTexts = ["in escrow", "released", "in escrow", "collected & leftover refunded"];
var aDay = 24 * 60 * 60;
var sevenDays = aDay * 7;
var threeDays = aDay * 3;

var currentTime = function currentTime() {
  return Math.floor(Date.now() / 1000);
};

var Loan =
/*#__PURE__*/
function () {
  function Loan(loan, loanManagerAddress, tokenAddress) {
    _classCallCheck(this, Loan);

    var _loan = _slicedToArray(loan, 12),
        configId = _loan[0],
        configCollateralAmount = _loan[1],
        configRepaymentAmount = _loan[2],
        configBorrower = _loan[3],
        configProductId = _loan[4],
        configState = _loan[5],
        configMaturity = _loan[6],
        configDisbursementTime = _loan[7],
        configLoanAmount = _loan[8],
        configInterestAmount = _loan[9],
        configMarginCallRate = _loan[10],
        configIsCollectable = _loan[11];

    this.loanManagerAddress = loanManagerAddress;
    this.tokenAddress = tokenAddress;
    var maturity = parseInt(configMaturity, 10);

    if (maturity > 0) {
      var disbursementTime = parseInt(configDisbursementTime, 10);
      var state = parseInt(configState, 10);
      this.id = parseInt(configId, 10);
      this.collateralAmount = Wei.parse(configCollateralAmount);
      this.borrower = '0x' + Web3.utils.toBN(configBorrower).toString(16).padStart(40, '0');
      this.productId = parseInt(configProductId, 10);
      this.state = state;
      this.maturity = maturity;
      this.disbursementTime = disbursementTime;
      this.interestAmount = Tokens.parse(configInterestAmount);
      this.loanAmount = Tokens.parse(configLoanAmount);
      this.repaymentAmount = Tokens.parse(configRepaymentAmount);

      if (configMarginCallRate !== undefined) {
        this.marginCallRate = Tokens.parse(configMarginCallRate);
        this._isCollectable = configIsCollectable === '1';
      }
    }
  }

  _createClass(Loan, [{
    key: "calculateCollateralRatio",
    // calculates the actual collateral ratio at a given rate (e.g. current)
    value: function calculateCollateralRatio(currentRate) {
      return this.collateralAmount.toTokens(currentRate).divToRatio(this.repaymentAmount);
    } // calculates the required change in collateral amount to reach a target collateral ratio
    // positive value means collateral has to be increased to reach target,
    // negative value means collateral could be decreased to reach target

  }, {
    key: "calculateCollateralChange",
    value: function calculateCollateralChange(currentRate, targetRatio) {
      return this.repaymentAmount.mulCeil(targetRatio).toWei(currentRate).sub(this.collateralAmount);
    } // calculates the resulting collateral ratio if collateral amount were changed by collateralChange wei
    // positive collateralChange means the collateral was increased, negative means it was decreased

  }, {
    key: "calculateCollateralRatioChange",
    value: function calculateCollateralRatioChange(currentRate, collateralChange) {
      return this.collateralAmount.add(collateralChange).toTokens(currentRate).divToRatio(this.repaymentAmount);
    }
  }, {
    key: "isMarginLoan",
    get: function get() {
      return !!this.marginCallRate;
    }
  }, {
    key: "term",
    get: function get() {
      return this.maturity - this.disbursementTime;
    }
  }, {
    key: "isRepayable",
    get: function get() {
      return this.state === LOAN_STATES.Open && currentTime() < this.maturity;
    }
  }, {
    key: "isCollectable",
    get: function get() {
      return this.isMarginLoan ? this._isCollectable : this.state === LOAN_STATES.Defaulted;
    }
  }, {
    key: "isDue",
    get: function get() {
      return this.state === LOAN_STATES.Open && this.maturity - currentTime() < sevenDays;
    }
  }, {
    key: "isExpired",
    get: function get() {
      return this.maturity < currentTime();
    }
  }, {
    key: "isRepaid",
    get: function get() {
      return this.state === LOAN_STATES.Repaid;
    }
  }, {
    key: "isCollected",
    get: function get() {
      return this.state === LOAN_STATES.Collected;
    }
  }, {
    key: "collateralStatus",
    get: function get() {
      return collateralStatusTexts[this.state] || "Invalid status";
    }
  }, {
    key: "dueState",
    get: function get() {
      return this.isDue ? this.maturity - currentTime() < threeDays ? "danger" : "warning" : "";
    }
  }]);

  return Loan;
}();

var LoanProduct =
/*#__PURE__*/
function () {
  function LoanProduct(loanProductTuple, loanManagerAddress) {
    _classCallCheck(this, LoanProduct);

    // Solidity LoanManager contract .getProducts() tuple:
    // [id, minDisbursedAmount, term, discountRate, collateralRatio, defaultingFeePt, maxLoanAmount, isActive, minCollateralRatio ]
    var _loanProductTuple = _slicedToArray(loanProductTuple, 9),
        sId = _loanProductTuple[0],
        sMinDisbursedAmount = _loanProductTuple[1],
        sTerm = _loanProductTuple[2],
        sDiscountRate = _loanProductTuple[3],
        sCollateralRatio = _loanProductTuple[4],
        sDefaultingFeePt = _loanProductTuple[5],
        sMaxLoanAmount = _loanProductTuple[6],
        sIsActive = _loanProductTuple[7],
        sMinCollateralRatio = _loanProductTuple[8];

    if (sTerm === "0") {
      throw new AugmintJsError("LoanManager.LoanProduct internal error: tried to instantiate a LoanProduct with 0 term. Did you try to create a Product from a dummy LoanProductTuple? ");
    }

    var termInSecs = parseInt(sTerm, 10);
    var discountRate = Ratio.parse(sDiscountRate); // this is an informative p.a. interest to displayed to the user - not intended to be used for calculations.
    //  The  interest  p.a. can be lower (but only lower or eq) depending on loan amount because of rounding

    var termInDays = termInSecs / 60 / 60 / 24;
    var interestRatePa = Math.round((1 / discountRate.toNumber() - 1) / termInDays * 365 * 10000) / 10000;
    var minDisbursedAmount = Tokens.parse(sMinDisbursedAmount); // adjusted minAmount. rational: ETH/EUR rate change in the background while sending the tx resulting tx rejected

    var adjustedMinDisbursedAmount = minDisbursedAmount.mul(MIN_LOAN_AMOUNT_ADJUSTMENT);
    this.id = parseInt(sId);
    this.termInSecs = termInSecs;
    this.discountRate = discountRate;
    this.interestRatePa = interestRatePa;
    this.minDisbursedAmount = minDisbursedAmount;
    this.adjustedMinDisbursedAmount = adjustedMinDisbursedAmount;
    this.maxLoanAmount = Tokens.parse(sMaxLoanAmount);
    this.defaultingFeePt = Ratio.parse(sDefaultingFeePt);
    this.isActive = sIsActive === "1";

    if (sMinCollateralRatio) {
      this.initialCollateralRatio = Ratio.parse(sCollateralRatio);
      this.minCollateralRatio = Ratio.parse(sMinCollateralRatio);
    } else {
      this.collateralRatio = Ratio.parse(sCollateralRatio);
    }

    this.loanManagerAddress = loanManagerAddress;
  }

  _createClass(LoanProduct, [{
    key: "calculateLoanFromCollateral",
    // Note: "disbursedAmount" is the loanAmount
    value: function calculateLoanFromCollateral(collateralAmount, ethFiatRate) {
      var tokenValue = collateralAmount.toTokens(ethFiatRate);
      var repaymentAmount = tokenValue.divFloor(this.getInitialCollateralRatio());
      var disbursedAmount = repaymentAmount.mulCeil(this.discountRate);
      var interestAmount = repaymentAmount.sub(disbursedAmount);
      var repayBefore = new Date();
      repayBefore.setSeconds(repayBefore.getSeconds() + this.termInSecs);
      return {
        disbursedAmount: disbursedAmount,
        collateralAmount: collateralAmount,
        repaymentAmount: repaymentAmount,
        interestAmount: interestAmount,
        repayBefore: repayBefore
      };
    } // Note: "disbursedAmount" is the loanAmount

  }, {
    key: "calculateLoanFromDisbursedAmount",
    value: function calculateLoanFromDisbursedAmount(disbursedAmount, ethFiatRate) {
      var repaymentAmount = disbursedAmount.divFloor(this.discountRate);
      var collateralValueInTokens = repaymentAmount.mulCeil(this.getInitialCollateralRatio());
      var collateralAmount = collateralValueInTokens.toWei(ethFiatRate);
      var repayBefore = new Date();
      repayBefore.setSeconds(repayBefore.getSeconds() + this.termInSecs);
      var result = {
        disbursedAmount: disbursedAmount,
        collateralAmount: collateralAmount,
        repaymentAmount: repaymentAmount,
        interestAmount: repaymentAmount.sub(disbursedAmount),
        repayBefore: repayBefore
      };
      return result;
    } // this is an estimate! use it only on new loan page!

  }, {
    key: "calculateMarginCallRate",
    value: function calculateMarginCallRate(ethFiatRate) {
      return ethFiatRate.mul(this.marginCallRateRatio);
    }
  }, {
    key: "getInitialCollateralRatio",
    value: function getInitialCollateralRatio() {
      return this.isMarginLoan ? this.initialCollateralRatio : Ratio.of(1).div(this.collateralRatio);
    }
  }, {
    key: "isMarginLoan",
    get: function get() {
      return !!(this.minCollateralRatio && this.initialCollateralRatio);
    }
  }, {
    key: "marginCallRateRatio",
    get: function get() {
      if (this.isMarginLoan) {
        return this.minCollateralRatio.div(this.initialCollateralRatio);
      }

      return Ratio.of(0);
    }
  }]);

  return LoanProduct;
}();

function isLoanManagerV0(instance) {
  return instance.methods.CHUNK_SIZE !== undefined;
}

function isLoanManagerPreMarginLoan(instance) {
  return !("addExtraCollateral" in instance.methods);
}
/**
 * Augmint LoanManager contract class
 * @class LoanManager
 * @extends Contract
 */


var LoanManager =
/*#__PURE__*/
function (_AbstractContract3) {
  _inherits(LoanManager, _AbstractContract3);

  function LoanManager(deployedContractInstance, ethereumConnection) {
    var _this23;

    _classCallCheck(this, LoanManager);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(LoanManager).call(this, deployedContractInstance));
    _this23.instance = deployedContractInstance;
    _this23.ethereumConnection = ethereumConnection;
    _this23.web3 = _this23.ethereumConnection.web3;
    return _this23;
  }

  _createClass(LoanManager, [{
    key: "getActiveProducts",
    value: function getActiveProducts() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this.getProducts(true));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "getAllProducts",
    value: function getAllProducts() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.getProducts(false));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    }
  }, {
    key: "newEthBackedLoan",
    value: function newEthBackedLoan(product, weiAmount, userAccount, minRate) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        var loanCount, gasEstimate, web3Tx;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.getLoanCount();

              case 2:
                loanCount = _context26.sent;
                gasEstimate = loanCount === 0 ? NEW_FIRST_LOAN_GAS : NEW_LOAN_GAS;

                if (isLoanManagerPreMarginLoan(this.instance)) {
                  _context26.next = 10;
                  break;
                }

                if (minRate) {
                  _context26.next = 7;
                  break;
                }

                throw new AugmintJsError('missing minRate in loanmanager!');

              case 7:
                web3Tx = this.instance.methods.newEthBackedLoan(product.id, minRate.toString());
                _context26.next = 13;
                break;

              case 10:
                if (!minRate) {
                  _context26.next = 12;
                  break;
                }

                throw new AugmintJsError('unexpected minRate in loanmanager!');

              case 12:
                web3Tx = this.instance.methods.newEthBackedLoan(product.id);

              case 13:
                return _context26.abrupt("return", new Transaction(this.ethereumConnection, web3Tx, {
                  gasLimit: gasEstimate,
                  from: userAccount,
                  value: weiAmount.amount
                }));

              case 14:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
  }, {
    key: "getLoansForAccount",
    value: function getLoansForAccount(userAccount) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        var chunkSize, loans, i, fetched;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                chunkSize = isLoanManagerV0(this.instance) ? LEGACY_CONTRACTS_CHUNK_SIZE : CHUNK_SIZE;
                loans = [];
                i = 0;

              case 3:
                _context27.next = 5;
                return this.getLoansForAccountChunk(userAccount, i * chunkSize, chunkSize);

              case 5:
                fetched = _context27.sent;
                loans.push.apply(loans, _toConsumableArray(fetched));
                i += 1;

              case 8:
                if (fetched.length === chunkSize) {
                  _context27.next = 3;
                  break;
                }

              case 9:
                return _context27.abrupt("return", loans);

              case 10:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "repayLoan",
    value: function repayLoan(loan, repaymentAmount, userAccount, augmintToken) {
      var augmintTokenInstance = augmintToken.instance;
      var web3Tx = augmintTokenInstance.methods.transferAndNotify(this.address, repaymentAmount.toString(), loan.id);
      return new Transaction(this.ethereumConnection, web3Tx, {
        gasLimit: REPAY_GAS,
        from: userAccount
      });
    }
  }, {
    key: "collectLoans",
    value: function collectLoans(loansToCollect, userAccount) {
      var gasEstimate = COLLECT_BASE_GAS + COLLECT_ONE_GAS * loansToCollect.length;
      var loanIdsToCollect = loansToCollect.map(function (loan) {
        return loan.id;
      });
      var web3Tx = this.instance.methods.collect(loanIdsToCollect);
      return new Transaction(this.ethereumConnection, web3Tx, {
        gasLimit: gasEstimate,
        from: userAccount
      });
    }
  }, {
    key: "getAllLoans",
    value: function getAllLoans() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        var chunkSize, loans, i, fetched;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                chunkSize = isLoanManagerV0(this.instance) ? LEGACY_CONTRACTS_CHUNK_SIZE : CHUNK_SIZE;
                loans = [];
                i = 0;

              case 3:
                _context28.next = 5;
                return this.getAllLoansChunk(i * chunkSize, chunkSize);

              case 5:
                fetched = _context28.sent;
                loans.push.apply(loans, _toConsumableArray(fetched));
                i += 1;

              case 8:
                if (fetched.length === chunkSize) {
                  _context28.next = 3;
                  break;
                }

              case 9:
                return _context28.abrupt("return", loans);

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "getLoanCount",
    value: function getLoanCount() {
      return this.instance.methods.getLoanCount().call().then(function (res) {
        return parseInt(res, 10);
      });
    }
  }, {
    key: "addExtraCollateral",
    value: function addExtraCollateral(loan, weiAmount, userAccount) {
      if (loan.isMarginLoan && !isLoanManagerPreMarginLoan(this.instance)) {
        var web3Tx = this.instance.methods.addExtraCollateral(loan.id);
        return new Transaction(this.ethereumConnection, web3Tx, {
          from: userAccount,
          value: weiAmount.amount
        });
      } else {
        throw new AugmintJsError('invalid call to addExtraCollateral');
      }
    }
  }, {
    key: "getLoansForAccountChunk",
    value: function getLoansForAccountChunk(userAccount, offset, chunkSize) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        var _this24 = this;

        var tokenAddress, loansArray;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.tokenAddress;

              case 2:
                tokenAddress = _context29.sent;

                if (!isLoanManagerV0(this.instance)) {
                  _context29.next = 9;
                  break;
                }

                _context29.next = 6;
                return this.instance.methods.getLoansForAddress(userAccount, offset).call();

              case 6:
                _context29.t0 = _context29.sent;
                _context29.next = 12;
                break;

              case 9:
                _context29.next = 11;
                return this.instance.methods.getLoansForAddress(userAccount, offset, chunkSize).call();

              case 11:
                _context29.t0 = _context29.sent;

              case 12:
                loansArray = _context29.t0;
                return _context29.abrupt("return", loansArray.filter(function (p) {
                  return p[3] !== "0";
                }).map(function (loan) {
                  return new Loan(loan, _this24.address, tokenAddress);
                }));

              case 14:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
  }, {
    key: "getAllLoansChunk",
    value: function getAllLoansChunk(offset, chunkSize) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        var _this25 = this;

        var tokenAddress, loansArray;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.tokenAddress;

              case 2:
                tokenAddress = _context30.sent;

                if (!isLoanManagerV0(this.instance)) {
                  _context30.next = 9;
                  break;
                }

                _context30.next = 6;
                return this.instance.methods.getLoans(offset).call();

              case 6:
                _context30.t0 = _context30.sent;
                _context30.next = 12;
                break;

              case 9:
                _context30.next = 11;
                return this.instance.methods.getLoans(offset, chunkSize).call();

              case 11:
                _context30.t0 = _context30.sent;

              case 12:
                loansArray = _context30.t0;
                return _context30.abrupt("return", loansArray.filter(function (p) {
                  return p[3] !== "0";
                }).map(function (loan) {
                  return new Loan(loan, _this25.address, tokenAddress);
                }));

              case 14:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "getProductsChunk",
    value: function getProductsChunk(offset, chunkSize) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31() {
        var _this26 = this;

        var prodArray;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (!isLoanManagerV0(this.instance)) {
                  _context31.next = 6;
                  break;
                }

                _context31.next = 3;
                return this.instance.methods.getProducts(offset).call();

              case 3:
                _context31.t0 = _context31.sent;
                _context31.next = 9;
                break;

              case 6:
                _context31.next = 8;
                return this.instance.methods.getProducts(offset, chunkSize).call();

              case 8:
                _context31.t0 = _context31.sent;

              case 9:
                prodArray = _context31.t0;
                return _context31.abrupt("return", prodArray.filter(function (p) {
                  return p[2] !== "0";
                }) // solidity can return only fixed size arrays so 0 terms means no product
                .map(function (tuple) {
                  return new LoanProduct(tuple, _this26.address);
                }));

              case 11:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    }
  }, {
    key: "getProducts",
    value: function getProducts(onlyActive) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        var chunkSize, products, i, fetched;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                chunkSize = isLoanManagerV0(this.instance) ? LEGACY_CONTRACTS_CHUNK_SIZE : CHUNK_SIZE;
                products = [];
                i = 0;

              case 3:
                _context32.next = 5;
                return this.getProductsChunk(i * chunkSize, chunkSize);

              case 5:
                fetched = _context32.sent;
                products.push.apply(products, _toConsumableArray(fetched));
                i += 1;

              case 8:
                if (fetched.length === chunkSize) {
                  _context32.next = 3;
                  break;
                }

              case 9:
                return _context32.abrupt("return", products.filter(function (p) {
                  return p.isActive || !onlyActive;
                }));

              case 10:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }
  }, {
    key: "tokenAddress",
    get: function get() {
      if (!this.augmintTokenAddress) {
        this.augmintTokenAddress = this.instance.methods.augmintToken().call();
      }

      return this.augmintTokenAddress;
    }
  }], [{
    key: "LoanProduct",
    get: function get() {
      return LoanProduct;
    }
  }, {
    key: "Loan",
    get: function get() {
      return Loan;
    }
  }]);

  return LoanManager;
}(AbstractContract);

var Rates =
/*#__PURE__*/
function (_AbstractContract4) {
  _inherits(Rates, _AbstractContract4);

  function Rates(deployedContractInstance, ethereumConnection) {
    var _this27;

    _classCallCheck(this, Rates);

    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Rates).call(this, deployedContractInstance));
    _this27.instance = deployedContractInstance;
    _this27.ethereumConnection = ethereumConnection;
    _this27.web3 = _this27.ethereumConnection.web3;
    return _this27;
  }

  _createClass(Rates, [{
    key: "getEthFiatRate",
    value: function getEthFiatRate(currency) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33() {
        var rate;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.instance.methods.convertFromWei(this.web3.utils.asciiToHex(currency), Wei.of(1).toString()).call().catch(function (error) {
                  if (error.message.includes("revert rates[bSymbol] must be > 0")) {
                    throw new ZeroRateError("getEthFiatRate returned zero rate for currency: ".concat(currency, ". Is it supported and has rate set in Rates contract?"));
                  } else {
                    throw error;
                  }
                });

              case 2:
                rate = _context33.sent;
                return _context33.abrupt("return", Tokens.parse(rate));

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));
    }
  }, {
    key: "getAugmintRate",
    value: function getAugmintRate(currency) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34() {
        var bytesCCY, storedRateInfo;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                bytesCCY = this.web3.utils.asciiToHex(currency);
                _context34.next = 3;
                return this.instance.methods.rates(bytesCCY).call();

              case 3:
                storedRateInfo = _context34.sent;
                return _context34.abrupt("return", {
                  rate: Tokens.parse(storedRateInfo.rate),
                  lastUpdated: new Date(parseInt(storedRateInfo.lastUpdated) * 1000)
                });

              case 5:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "setRate",
    value: function setRate(currency, price) {
      var bytesCCY = this.web3.utils.asciiToHex(currency);
      var web3Tx = this.instance.methods.setRate(bytesCCY, price.toString());
      var transaction = new Transaction(this.ethereumConnection, web3Tx, {
        gasLimit: SET_RATE_GAS_LIMIT,
        // setting to: in case it's going to be signed
        // NB: signing/sending this particular tx works without it somehow
        // but others are throwing unhandled rejection errors (web3 beta36) so setting a good example
        to: this.address
      });
      return transaction;
    }
  }]);

  return Rates;
}(AbstractContract);

var Augmint =
/*#__PURE__*/
function () {
  function Augmint(ethereumConnection, environment) {
    var _this28 = this;

    _classCallCheck(this, Augmint);

    this.loanManagers = new Map();
    this.ethereumConnection = ethereumConnection;
    this.web3 = this.ethereumConnection.web3;
    this.deployedEnvironment = environment;
    this.latestContracts = this.deployedEnvironment.getLatestContracts();

    if (this.deployedEnvironment.contracts[AugmintContracts.LoanManager]) {
      this.deployedEnvironment.contracts[AugmintContracts.LoanManager].forEach(function (contract) {
        return _this28.loanManagers.set(contract.deployedAddress.toLowerCase(), new LoanManager(contract.connect(_this28.web3), _this28.ethereumConnection));
      });
    }
  }

  _createClass(Augmint, [{
    key: "getLegacyTokens",
    value: function getLegacyTokens() {
      var _this29 = this;

      var addresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var legacyTokens = [];

      if (addresses.length === 0) {
        legacyTokens = this.deployedEnvironment.getLegacyContracts(AugmintContracts.TokenAEur);
      } else {
        legacyTokens = this.deployedEnvironment.getContractFromAddresses(AugmintContracts.TokenAEur, addresses);

        if (legacyTokens.length !== addresses.length) {
          throw new Error("legacy contracts length mismatch!");
        }
      }

      return legacyTokens.map(function (tokenContract) {
        return new AugmintToken(tokenContract.connect(_this29.web3), _this29.ethereumConnection);
      });
    } //  myaugmint.getLegacyExchanges(Augmint.constants.SUPPORTED_LEGACY_EXCHANGES)

  }, {
    key: "getLegacyExchanges",
    value: function getLegacyExchanges() {
      var _this30 = this;

      var addresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var legacyContracts = [];

      if (addresses.length === 0) {
        legacyContracts = this.deployedEnvironment.getLegacyContracts(AugmintContracts.Exchange);
      } else {
        legacyContracts = this.deployedEnvironment.getContractFromAddresses(AugmintContracts.Exchange, addresses);

        if (legacyContracts.length !== addresses.length) {
          throw new Error("legacy contracts length mismatch!");
        }
      }

      var options = {
        token: this.token,
        rates: this.rates,
        ethereumConnection: this.ethereumConnection
      };
      return legacyContracts.map(function (contract) {
        return new Exchange(contract.connect(_this30.web3), options);
      });
    } //  augmint.getLegacyLoanManagers(Augmint.constants.SUPPORTED_LEGACY_LOANMANAGERS)

  }, {
    key: "getLegacyLoanManagers",
    value: function getLegacyLoanManagers() {
      var _this31 = this;

      var addresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var legacyContracts = [];

      if (addresses.length === 0) {
        legacyContracts = this.deployedEnvironment.getLegacyContracts(AugmintContracts.LoanManager);
      } else {
        legacyContracts = this.deployedEnvironment.getContractFromAddresses(AugmintContracts.LoanManager, addresses);

        if (legacyContracts.length !== addresses.length) {
          throw new Error("legacy contracts length mismatch!");
        }
      }

      return legacyContracts.map(function (contract) {
        return new LoanManager(contract.connect(_this31.web3), _this31.ethereumConnection);
      });
    }
  }, {
    key: "getLoansForAccount",
    value: function getLoansForAccount(userAccount) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return collectPromises(this.getAllLoanManagers(), function (loanManager) {
                  return loanManager.getLoansForAccount(userAccount);
                });

              case 2:
                return _context35.abrupt("return", _context35.sent);

              case 3:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "getLoanProducts",
    value: function getLoanProducts(activeOnly) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return collectPromises(this.getAllLoanManagers(), function (loanManager) {
                  return activeOnly ? loanManager.getActiveProducts() : loanManager.getAllProducts();
                });

              case 2:
                return _context36.abrupt("return", _context36.sent);

              case 3:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "repayLoan",
    value: function repayLoan(loan, repaymentAmount, userAccount) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37() {
        var loanManager, tokenAddress, tokenContract, token;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                loanManager = this.getLoanManagerByAddress(loan.loanManagerAddress);
                _context37.next = 3;
                return loanManager.tokenAddress;

              case 3:
                tokenAddress = _context37.sent;
                tokenContract = this.deployedEnvironment.getContractFromAddress(AugmintContracts.TokenAEur, tokenAddress);
                token = new AugmintToken(tokenContract.connect(this.web3), this.ethereumConnection);
                return _context37.abrupt("return", loanManager.repayLoan(loan, repaymentAmount, userAccount, token));

              case 7:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "newEthBackedLoan",
    value: function newEthBackedLoan(loanProduct, weiAmount, userAccount, minRate) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        var loanManager;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                loanManager = this.getLoanManagerByAddress(loanProduct.loanManagerAddress);
                return _context38.abrupt("return", loanManager.newEthBackedLoan(loanProduct, weiAmount, userAccount, minRate));

              case 2:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
  }, {
    key: "getAllLoans",
    value: function getAllLoans() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return collectPromises(this.getAllLoanManagers(), function (loanManager) {
                  return loanManager.getAllLoans();
                });

              case 2:
                return _context39.abrupt("return", _context39.sent);

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "getLoansToCollect",
    value: function getLoansToCollect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40() {
        var allLoans;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.getAllLoans();

              case 2:
                allLoans = _context40.sent;
                return _context40.abrupt("return", allLoans.filter(function (loan) {
                  return loan.isCollectable;
                }));

              case 4:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "collectLoans",
    value: function collectLoans(loansToCollect, userAccount) {
      var currentAddress = null;
      var loanManager = null;
      var result = [];
      var loans = [];
      loansToCollect.sort(function (a, b) {
        return a.loanManagerAddress < b.loanManagerAddress ? 1 : -1;
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = loansToCollect[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var loan = _step2.value;

          if (currentAddress !== loan.loanManagerAddress) {
            if (currentAddress !== null && loanManager !== null) {
              result.push(loanManager.collectLoans(loans, userAccount));
            }

            loanManager = this.getLoanManagerByAddress(loan.loanManagerAddress);
            loans = [];
          }

          currentAddress = loan.loanManagerAddress;
          loans.push(loan);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (loanManager) {
        result.push(loanManager.collectLoans(loans, userAccount));
      }

      return result;
    }
  }, {
    key: "getLoanCounts",
    value: function getLoanCounts() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        var result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, loanManager, loanCount;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                result = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context41.prev = 4;
                _iterator3 = this.getAllLoanManagers()[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context41.next = 15;
                  break;
                }

                loanManager = _step3.value;
                _context41.next = 10;
                return loanManager.getLoanCount();

              case 10:
                loanCount = _context41.sent;
                result.push({
                  loanManagerAddress: loanManager.address,
                  loanCount: loanCount
                });

              case 12:
                _iteratorNormalCompletion3 = true;
                _context41.next = 6;
                break;

              case 15:
                _context41.next = 21;
                break;

              case 17:
                _context41.prev = 17;
                _context41.t0 = _context41["catch"](4);
                _didIteratorError3 = true;
                _iteratorError3 = _context41.t0;

              case 21:
                _context41.prev = 21;
                _context41.prev = 22;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 24:
                _context41.prev = 24;

                if (!_didIteratorError3) {
                  _context41.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context41.finish(24);

              case 28:
                return _context41.finish(21);

              case 29:
                return _context41.abrupt("return", result);

              case 30:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this, [[4, 17, 21, 29], [22,, 24, 28]]);
      }));
    }
  }, {
    key: "addExtraCollateral",
    value: function addExtraCollateral(loan, weiAmount, userAccount) {
      var loanManager = this.getLoanManagerByAddress(loan.loanManagerAddress);
      return loanManager.addExtraCollateral(loan, weiAmount, userAccount);
    }
  }, {
    key: "getAllLoanManagers",
    value: function getAllLoanManagers() {
      return Array.from(this.loanManagers.values());
    }
  }, {
    key: "getLoanManagerByAddress",
    value: function getLoanManagerByAddress(address) {
      var loanManager = this.loanManagers.get(address.toLowerCase());

      if (!loanManager) {
        throw new Error("environment configuration error: there is no loanmanager at " + address);
      }

      return loanManager;
    }
  }, {
    key: "token",
    get: function get() {
      if (!this._token) {
        var tokenContract = this.deployedEnvironment.getLatestContract(AugmintContracts.TokenAEur);
        this._token = new AugmintToken(tokenContract.connect(this.web3), this.ethereumConnection);
      }

      return this._token;
    }
  }, {
    key: "rates",
    get: function get() {
      if (!this._rates) {
        var ratesContract = this.deployedEnvironment.getLatestContract(AugmintContracts.Rates);
        this._rates = new Rates(ratesContract.connect(this.web3), this.ethereumConnection);
      }

      return this._rates;
    }
  }, {
    key: "exchange",
    get: function get() {
      if (!this._exchange) {
        var exchangeContract = this.deployedEnvironment.getLatestContract(AugmintContracts.Exchange);
        this._exchange = new Exchange(exchangeContract.connect(this.web3), {
          token: this.token,
          rates: this.rates,
          ethereumConnection: this.ethereumConnection
        });
      }

      return this._exchange;
    }
  }], [{
    key: "create",
    value: function create(connectionOptions, environment) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42() {
        var ethereumConnection, networkId, selectedDeployedEnvironment;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                ethereumConnection = new EthereumConnection(connectionOptions);
                _context42.next = 3;
                return ethereumConnection.connect();

              case 3:
                if (!environment) {
                  networkId = ethereumConnection.networkId.toString(10);
                  selectedDeployedEnvironment = deployedEnvironments.find(function (item) {
                    return item.name === networkId;
                  });
                  environment = selectedDeployedEnvironment;
                }

                if (environment) {
                  _context42.next = 6;
                  break;
                }

                throw new Error("Missing environment, cannot create Augmint");

              case 6:
                return _context42.abrupt("return", new Augmint(ethereumConnection, environment));

              case 7:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));
    }
  }, {
    key: "generateDeploymentEnvironment",
    value: function generateDeploymentEnvironment(environmentName, stubs) {
      var deployedEnvironment = new DeployedEnvironment(environmentName);
      Object.keys(stubs).forEach(function (stub) {
        var role = stub;
        var contractListStub = stubs[stub];
        deployedEnvironment.addRole(role, contractListStub.map(function (contractStub) {
          return new DeployedContract(contractStub);
        }));
      });
      return deployedEnvironment;
    }
  }, {
    key: "constants",
    get: function get() {
      return constants;
    }
  }, {
    key: "gas",
    get: function get() {
      return gas;
    }
  }, {
    key: "EthereumConnection",
    get: function get() {
      return EthereumConnection;
    }
  }, {
    key: "AugmintToken",
    get: function get() {
      return AugmintToken;
    }
  }, {
    key: "Errors",
    get: function get() {
      return Errors;
    }
  }, {
    key: "Transaction",
    get: function get() {
      return Transaction;
    }
  }, {
    key: "Exchange",
    get: function get() {
      return Exchange;
    }
  }, {
    key: "LoanManager",
    get: function get() {
      return LoanManager;
    }
  }]);

  return Augmint;
}();

export { Augmint, Ratio, Tokens, Wei, index as utils };